(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3817,1197],{

/***/ 57827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgDropdownCaret = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 10,
  height: 6,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M9 1 5 5 1 1",
  stroke: "#B18D3B",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgDropdownCaret);

/***/ }),

/***/ 83316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconBedroom = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 26 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M24.819 3.6V18M1.182 0v18M1.182 8.4h23.636M1.182 8.4V4.8h7.681v3.6M1.182 13.2h23.636",
  stroke: "currentColor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconBedroom);

/***/ }),

/***/ 73553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconCheckboxCheck = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 27",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M13.172.939c-.28.004-.548.115-.748.312l-4.026 3.92L4.37 9.09 2.823 5.456a1.09 1.09 0 0 0-1.438-.593 1.084 1.084 0 0 0-.56 1.45l2.173 5.086a1.086 1.086 0 0 0 1.758.355l9.186-8.945c.322-.31.422-.785.253-1.198a1.089 1.089 0 0 0-1.023-.672Z",
  fill: "currentColor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconCheckboxCheck);

/***/ }),

/***/ 92562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconFavourite = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M13 25s12-8.516 12-18.194A5.809 5.809 0 0 0 19.194 1C15.988 1 13 3.601 13 6.806 13 3.601 10.012 1 6.806 1A5.809 5.809 0 0 0 1 6.806C1 16.484 13 25 13 25Z",
  fill: "currentColor",
  stroke: "#fff",
  strokeWidth: 1.6,
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconFavourite);

/***/ }),

/***/ 4860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconSearch = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 27 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12.262 22.286c5.883 0 10.652-4.769 10.652-10.652C22.914 5.75 18.145.98 12.262.98c-5.883 0-10.653 4.77-10.653 10.653 0 5.883 4.77 10.652 10.653 10.652ZM25.61 24.982l-5.825-5.804",
  stroke: "currentcolor",
  strokeWidth: 1.6,
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconSearch);

/***/ }),

/***/ 75455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77627);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64636);



var Bedrooms = function(param) {
    var value = param.value, setValue = param.setValue, _bedroom = param.bedroom, bedroom = _bedroom === void 0 ? false : _bedroom, _items = param.items, items = _items === void 0 ? 8 : _items, _name = param.name, name = _name === void 0 ? "bedrooms" : _name;
    return Array.from({
        length: items
    }).map(function(currentElement, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().radio),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                    type: "radio",
                    onChange: function(e) {
                        setValue(parseInt(e.target.value));
                    },
                    checked: value === index + 1,
                    name: name,
                    value: index + 1
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().radio__content),
                    children: !bedroom && index === 7 ? "8+" : index + 1
                })
            ]
        }, index + 1);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Bedrooms);


/***/ }),

/***/ 42192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65097);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _public_icons_dropdown_caret_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57827);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34495);






var Accordion = function(param) {
    var title = param.title, children = param.children, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, index = param.index, openKey = param.openKey, setOpenKey = param.setOpenKey;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), open = ref[0], setOpen = ref[1];
    var isLarge = variant.includes("large");
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (setOpenKey) {
            if (index === openKey) {
                setOpen(true);
            } else {
                setOpen(false);
            }
        }
    }, [
        openKey
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_3__/* .withModifiers */ .i)("accordion", [
            open && "is-open"
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(variant)), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default())),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                onClick: function() {
                    if (setOpenKey) {
                        setOpenKey(index);
                        if (openKey === index) {
                            setOpenKey(null);
                        }
                    } else {
                        setOpen(!open);
                    }
                },
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordion__trigger),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordion__title),
                        children: title && title
                    }),
                    isLarge ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordion__plus),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordion__line)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordion__line)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_icons_dropdown_caret_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordion__caret)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordion__content),
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);


/***/ }),

/***/ 41197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ elements_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/elements/Button/styles.module.scss
var styles_module = __webpack_require__(80111);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-cta.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconCta = props => /*#__PURE__*/react.createElement("svg", _extends({
  viewBox: "0 0 26 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M20.94 10 24 5.954m0 0L21.001 2M24 5.954l-23 .1",
  stroke: "currentcolor",
  strokeWidth: 1.6,
  strokeLinecap: "square"
})));

/* harmony default export */ var icon_cta = (SvgIconCta);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./components/elements/Button/wrappers/styles.module.scss
var wrappers_styles_module = __webpack_require__(67912);
var wrappers_styles_module_default = /*#__PURE__*/__webpack_require__.n(wrappers_styles_module);
;// CONCATENATED MODULE: ./components/elements/Button/wrappers/withDisabled.js






var withDisabled = function(Component) {
    return function Wrapper(props) {
        var ref = (0,react.useState)(false), ready = ref[0], setReady = ref[1];
        (0,react.useEffect)(function() {
            setReady(true);
        }, []);
        if (props.disabled && ready) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(props.className, (0,withModifiers/* withModifiers */.i)("disabled", props.variant, (wrappers_styles_module_default()))),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, props))
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, props));
    };
};
/* harmony default export */ var wrappers_withDisabled = (withDisabled);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/elements/Button/index.js
/* eslint-disable react/prop-types */ 










var Button = function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, children = _param.children, className = _param.className, disabled = _param.disabled, _arrow = _param.arrow, arrow = _arrow === void 0 ? true : _arrow, type = _param.type, prepend = _param.prepend, buttonRef = _param.buttonRef, onClick = _param.onClick, href = _param.href, _name = _param.name, name = _name === void 0 ? "action button" : _name, _appendIcon = _param.appendIcon, appendIcon = _appendIcon === void 0 ? false : _appendIcon, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "children",
        "className",
        "disabled",
        "arrow",
        "type",
        "prepend",
        "buttonRef",
        "onClick",
        "href",
        "name",
        "appendIcon"
    ]);
    var isSmallMobile = (0,ResponsiveContext/* useResponsive */.F)().isSmallMobile;
    if (href) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: classnames_default()(className, (0,withModifiers/* withModifiers */.i)("button", variant, (styles_module_default()))),
                ref: buttonRef,
                type: type,
                disabled: disabled,
                onClick: onClick ? onClick : undefined
            }, props), {
                children: [
                    prepend && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).button__prepend,
                        children: prepend
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).button__label,
                        children: children
                    }),
                    arrow && !appendIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_cta, {
                        width: isSmallMobile ? 17 : 23,
                        className: (styles_module_default()).button__arrow
                    }),
                    appendIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).button__append,
                        children: appendIcon
                    })
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classnames_default()(className, (0,withModifiers/* withModifiers */.i)("button", variant, (styles_module_default()))),
        href: href,
        ref: buttonRef,
        type: type,
        name: name,
        disabled: disabled,
        onClick: onClick ? onClick : undefined
    }, props), {
        children: [
            prepend && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).button__prepend,
                children: prepend
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).button__label,
                children: children
            }),
            arrow && !appendIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_cta, {
                width: isSmallMobile ? 17 : 23,
                className: (styles_module_default()).button__arrow
            }),
            appendIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).button__append,
                children: appendIcon
            })
        ]
    }));
};
/* harmony default export */ var elements_Button = (wrappers_withDisabled(Button));


/***/ }),

/***/ 51524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable react/prop-types */ 


var Container = function(param) {
    var children = param.children, className = param.className, variant = param.variant;
    var containerVariant = variant ? variant : [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default().apply(void 0, [
            "container",
            className
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(containerVariant))),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Container);


/***/ }),

/***/ 85137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ elements_DateSearch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 1 modules
var formik_esm = __webpack_require__(64636);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/elements/DateSearch/styles.module.scss
var styles_module = __webpack_require__(22648);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./components/elements/form/CustomField/index.js + 1 modules
var CustomField = __webpack_require__(56375);
;// CONCATENATED MODULE: ./public/icons/icon-listing.svg
var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconListing = props => /*#__PURE__*/react.createElement("svg", _extends({
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M24.862 1H13.316L2.091 12.351C.73 13.727.628 15.835 1.865 17.055l7.206 7.108c1.236 1.22 3.343 1.09 4.706-.285L25 12.526V1h-.138Z",
  stroke: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M19.293 6.683c.673.664 1.753.66 2.414-.009a1.703 1.703 0 0 0-.021-2.412 1.707 1.707 0 0 0-2.415.01 1.703 1.703 0 0 0 .022 2.411Z",
  stroke: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "m13.719 8.511-7.4 7.57",
  stroke: "currentcolor"
})), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  d: "m15.564 10.309-7.4 7.57M17.237 11.943l-7.397 7.57",
  stroke: "currentColor"
})));

/* harmony default export */ var icon_listing = (SvgIconListing);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./providers/SearchContext.js
var SearchContext = __webpack_require__(65079);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
;// CONCATENATED MODULE: ./public/icons/icon-homeType.svg
var icon_homeType_path, icon_homeType_path2, icon_homeType_path3;

function icon_homeType_extends() { icon_homeType_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_homeType_extends.apply(this, arguments); }



const SvgIconHomeType = props => /*#__PURE__*/react.createElement("svg", icon_homeType_extends({
  viewBox: "0 0 28 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_homeType_path || (icon_homeType_path = /*#__PURE__*/react.createElement("path", {
  d: "M1 25h26M8.313 25V5.55M4.656 13c0-3.886.813-7.035 3.657-7.035 2.843 0 3.656 3.149 3.656 7.034",
  stroke: "currentColor"
})), icon_homeType_path2 || (icon_homeType_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M1.406 13H15.22c0-3.886-3.092-7.035-6.906-7.035-3.815 0-6.907 3.149-6.907 7.034ZM10.344 22.518h10.562L23.344 25M12.781 22.518 10.344 25M14.406 22.517l-3.656-3.724M18.469 22.517l-1.625-1.656H12.78M18.063 5.139c2.437 0 2.843 1.655 2.843 1.655s.407-1.655 2.844-1.655M20.906 6.793v.414",
  stroke: "currentColor"
})), icon_homeType_path3 || (icon_homeType_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M12.543 5.548C13.656 2.874 16.252 1 19.283 1c4.038 0 7.312 3.335 7.312 7.448s-3.274 7.449-7.312 7.449a7.183 7.183 0 0 1-4.266-1.4",
  stroke: "currentColor"
})));

/* harmony default export */ var icon_homeType = (SvgIconHomeType);
;// CONCATENATED MODULE: ./public/icons/icon-price-range.svg
var icon_price_range_path, icon_price_range_path2, icon_price_range_path3;

function icon_price_range_extends() { icon_price_range_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_price_range_extends.apply(this, arguments); }



const SvgIconPriceRange = props => /*#__PURE__*/react.createElement("svg", icon_price_range_extends({
  viewBox: "0 0 28 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_price_range_path || (icon_price_range_path = /*#__PURE__*/react.createElement("path", {
  d: "M2.258 14.286c.695 0 1.258-.575 1.258-1.285s-.563-1.286-1.258-1.286C1.563 11.715 1 12.29 1 13c0 .71.563 1.285 1.258 1.285ZM25.742 14.286c.695 0 1.258-.575 1.258-1.285s-.563-1.286-1.258-1.286c-.694 0-1.258.575-1.258 1.286 0 .71.564 1.285 1.258 1.285ZM23.647 3.574v2.572h-2.516M4.355 22.431v-2.572h2.517",
  stroke: "currentColor"
})), icon_price_range_path2 || (icon_price_range_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M25.684 14.227C25.084 20.278 20.08 25 14 25c-3.988 0-7.514-2.035-9.636-5.143M2.324 11.72C2.95 5.692 7.94 1 14 1c3.989 0 7.515 2.036 9.637 5.143",
  stroke: "currentColor"
})), icon_price_range_path3 || (icon_price_range_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M11.562 15.499c0 1.376 1.095 2.494 2.44 2.494 1.347 0 2.442-1.118 2.442-2.494 0-1.376-2.441-2.495-2.441-2.495s-2.44-1.118-2.44-2.494c0-1.376 1.094-2.494 2.44-2.494 1.346 0 2.44 1.118 2.44 2.494M13.998 8.006V5.512M13.998 17.992v2.495",
  stroke: "currentColor"
})));

/* harmony default export */ var icon_price_range = (SvgIconPriceRange);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/elements/DateSearch/components/Dates/index.js



// Lazily load DatesRangePicker component
var DatesRangePicker = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2756), __webpack_require__.e(4291), __webpack_require__.e(4040), __webpack_require__.e(3871)]).then(__webpack_require__.bind(__webpack_require__, 23871));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23871)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return null;
    }
});
var Dates = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _form = param.form, setFieldValue = _form.setFieldValue, values = _form.values, shadowRef = param.shadowRef, setCalendarActive = param.setCalendarActive, custom = param.custom, _icon = param.icon, icon = _icon === void 0 ? false : _icon, translations = param.translations, width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatesRangePicker, {
        form: {
            setFieldValue: setFieldValue,
            values: values
        },
        shadowRef: shadowRef,
        setCalendarActive: setCalendarActive,
        custom: custom,
        icon: icon,
        translations: translations,
        width: width
    });
});
// Display name for debugging
Dates.displayName = "Dates";
/* harmony default export */ var components_Dates = (Dates);

// EXTERNAL MODULE: ./components/elements/DateSearch/components/Bedrooms/styles.module.scss
var Bedrooms_styles_module = __webpack_require__(44234);
var Bedrooms_styles_module_default = /*#__PURE__*/__webpack_require__.n(Bedrooms_styles_module);
// EXTERNAL MODULE: ./public/icons/icon-bedroom.svg
var icon_bedroom = __webpack_require__(83316);
// EXTERNAL MODULE: ./components/custom/Bedrooms/index.js
var Bedrooms = __webpack_require__(75455);
;// CONCATENATED MODULE: ./components/elements/DateSearch/components/Bedrooms/index.js










// Using memo to prevent unnecessary re-renders
var Bedroom = /*#__PURE__*/ (0,react.memo)(function(param) {
    var setFieldValue = param.setFieldValue, shadowRef = param.shadowRef, setBedroomActive = param.setBedroomActive, custom = param.custom, width = param.width, translations = param.translations;
    var ref = (0,SearchContext/* useSearchContext */.AB)(), search = ref.search, setSearch = ref.setSearch;
    var ref1 = (0,react.useState)(false), show = ref1[0], setShow = ref1[1];
    var ref2 = (0,react.useState)((search === null || search === void 0 ? void 0 : search.bedrooms) || null), value = ref2[0], setValue = ref2[1];
    var ref3 = (0,react.useState)(false), contentMounted = ref3[0], setContentMounted = ref3[1];
    var wrapperRef = (0,react.useRef)(null);
    var isMobile = (0,ResponsiveContext/* useResponsive */.F)().isMobile;
    var router = (0,next_router.useRouter)();
    // Ref to track value updates and prevent loops
    var valueRef = (0,react.useRef)(value);
    // Custom setValue function that updates both local state and form
    var handleSetValue = (0,react.useCallback)(function(newValue) {
        // Update local state
        setValue(newValue);
        // Update form field
        setFieldValue("bedrooms", newValue);
        // Update search context
        // Update ref for comparison
        valueRef.current = newValue;
    }, [
        setFieldValue,
        setSearch
    ]);
    // Memoize the click outside handler to prevent recreating on each render
    var handleClickOutside = (0,react.useCallback)(function(event) {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShow(false);
        }
    }, []);
    // Set up and clean up click outside handler
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    // Sync with search context - only update if there's a real change
    (0,react.useEffect)(function() {
        if (search.bedrooms !== valueRef.current) {
            setValue(search.bedrooms);
            valueRef.current = search.bedrooms;
        }
    }, [
        search.bedrooms
    ]);
    // Handle shadow overlay
    (0,react.useEffect)(function() {
        if (shadowRef) {
            if (show) {
                var ref;
                (ref = shadowRef.current) === null || ref === void 0 ? void 0 : ref.classList.add("isVisible");
            } else {
                var ref1;
                (ref1 = shadowRef.current) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("isVisible");
            }
        }
    }, [
        shadowRef,
        show
    ]);
    // Update parent component's active state
    (0,react.useEffect)(function() {
        if (setBedroomActive) {
            setBedroomActive(show || value);
        }
    }, [
        show,
        value,
        setBedroomActive
    ]);
    // Handle toggle show/hide
    var toggleShow = (0,react.useCallback)(function() {
        setShow(function(prevShow) {
            return !prevShow;
        });
    }, []);
    // Generate the display text
    var displayText = value ? "".concat(translations.bedrooms[router.locale], ": ").concat(value) : translations.bedrooms[router.locale];
    // Use effect to handle mounting/unmounting with proper timing for transitions
    (0,react.useEffect)(function() {
        if (show) {
            // When opening, mount content immediately
            setContentMounted(true);
        } else if (!show && contentMounted) {
            // When closing, wait for transition to finish before unmounting
            var transitionDuration = 300 // Match this with your CSS transition duration
            ;
            var timer = setTimeout(function() {
                setContentMounted(false);
            }, transitionDuration);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        show,
        contentMounted
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: wrapperRef,
        className: (Bedrooms_styles_module_default()).field,
        role: "group",
        "aria-labelledby": "bedrooms-group",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                "aria-label": "Select Bedroom Option",
                type: "text",
                readOnly: true,
                angle: true,
                variant: [
                    isMobile && "full-width"
                ],
                prependIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_bedroom/* default */.Z, {
                    width: 26,
                    height: 26
                }),
                width: width,
                onClick: toggleShow,
                isActive: value || show,
                value: displayText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Bedrooms_styles_module_default()).field__radios, show && (Bedrooms_styles_module_default()).isShown, custom && (Bedrooms_styles_module_default()).custom),
                children: contentMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Bedrooms/* default */.Z, {
                    value: value,
                    setValue: handleSetValue
                })
            })
        ]
    });
});
// Display name for debugging
Bedroom.displayName = "Bedroom";
/* harmony default export */ var components_Bedrooms = (Bedroom);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react-input-range/lib/js/index.js
var js = __webpack_require__(9322);
var js_default = /*#__PURE__*/__webpack_require__.n(js);
// EXTERNAL MODULE: ./node_modules/react-input-range/lib/css/index.css
var css = __webpack_require__(59069);
// EXTERNAL MODULE: ./components/elements/DateSearch/components/Price/styles.module.scss
var Price_styles_module = __webpack_require__(24199);
var Price_styles_module_default = /*#__PURE__*/__webpack_require__.n(Price_styles_module);
;// CONCATENATED MODULE: ./components/elements/DateSearch/components/Price/index.js











var Price = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var setFieldValue = _param.form.setFieldValue, setPriceActive = _param.setPriceActive, shadowRef = _param.shadowRef, price = _param.price, translation = _param.translation, props = (0,_object_without_properties/* default */.Z)(_param, [
        "form",
        "setPriceActive",
        "shadowRef",
        "price",
        "translation"
    ]);
    var ref = (0,react.useState)({
        min: 0,
        max: price
    }), value = ref[0], setValue = ref[1];
    var search = (0,SearchContext/* useSearchContext */.AB)().search;
    var ref1 = (0,react.useState)(false), show = ref1[0], setShow = ref1[1];
    var wrapperRef = (0,react.useRef)(null);
    var isTablet = (0,ResponsiveContext/* useResponsive */.F)().isTablet;
    // Memoize click outside handler
    var handleClickOutside = (0,react.useCallback)(function(event) {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShow(false);
        }
    }, []);
    // Set up click outside handler
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    // Memoize input range change handler
    var handleChange = (0,react.useCallback)(function(newValue) {
        // Use precision formatting for numeric values
        var formattedValue = {
            min: Number(newValue.min.toFixed(2)),
            max: Number(newValue.max.toFixed(2))
        };
        setValue(formattedValue);
        setFieldValue("priceStart", formattedValue.min);
        setFieldValue("priceEnd", formattedValue.max);
    }, [
        setFieldValue
    ]);
    // Sync with search context
    (0,react.useEffect)(function() {
        if (search.priceStart !== null || search.priceEnd !== null) {
            var _priceStart, _priceEnd;
            setValue({
                min: (_priceStart = search.priceStart) !== null && _priceStart !== void 0 ? _priceStart : 0,
                max: (_priceEnd = search.priceEnd) !== null && _priceEnd !== void 0 ? _priceEnd : price
            });
        }
    }, [
        search.priceEnd,
        search.priceStart,
        price
    ]);
    // Update parent component's active state
    (0,react.useEffect)(function() {
        if (setPriceActive) {
            setPriceActive(value.max !== price || value.min !== 0);
        }
    }, [
        value,
        price,
        setPriceActive
    ]);
    // Update form values when local state changes
    (0,react.useEffect)(function() {
        setFieldValue("priceStart", value.min);
        setFieldValue("priceEnd", value.max);
    }, [
        value,
        setFieldValue
    ]);
    // Handle shadow overlay
    (0,react.useEffect)(function() {
        if (shadowRef) {
            if (show) {
                var ref;
                (ref = shadowRef.current) === null || ref === void 0 ? void 0 : ref.classList.add("isVisible");
            } else {
                var ref1;
                (ref1 = shadowRef.current) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("isVisible");
            }
        }
    }, [
        shadowRef,
        show
    ]);
    // Toggle show/hide
    var toggleShow = (0,react.useCallback)(function() {
        setShow(function(prev) {
            return !prev;
        });
    }, []);
    // Input range change handler with validation
    var handleRangeChange = (0,react.useCallback)(function(newValue) {
        if (newValue.min >= 0.0 && newValue.max <= price) {
            handleChange(newValue);
        }
    }, [
        handleChange,
        price
    ]);
    // Generate display value for the field
    var displayValue = value.max !== price || value.min !== 0 ? "".concat(value.min, " K - ").concat(value.max, " K") : translation;
    // Check if price range is active
    var isPriceActive = value.max !== price || value.min !== 0;
    // Track if price range content should be in DOM with a separate state
    var ref2 = (0,react.useState)(false), rangeMounted = ref2[0], setRangeMounted = ref2[1];
    // Use effect to handle mounting/unmounting with proper timing for transitions
    (0,react.useEffect)(function() {
        if (show) {
            // When opening, mount content immediately
            setRangeMounted(true);
        } else if (!show && rangeMounted) {
            // When closing, wait for transition to finish before unmounting
            var transitionDuration = 300 // Match this with your CSS transition duration
            ;
            var timer = setTimeout(function() {
                setRangeMounted(false);
            }, transitionDuration);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        show,
        rangeMounted
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: wrapperRef,
        className: (Price_styles_module_default()).field,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, (0,_object_spread/* default */.Z)({
                type: "text",
                "aria-label": "Select Price Range",
                readOnly: true,
                angle: true,
                variant: [
                    isTablet && "full-width"
                ],
                onClick: toggleShow,
                isActive: isPriceActive,
                value: displayValue
            }, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Price_styles_module_default()).field__radios, show && (Price_styles_module_default()).isShown),
                children: rangeMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "range",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((js_default()), {
                            maxValue: price,
                            minValue: 0.0,
                            value: value,
                            formatLabel: function() {
                                return null;
                            },
                            step: 0.1,
                            onChange: handleRangeChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "range__labels",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "".concat(value.min, " K")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "".concat(value.max, " K")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});
// Display name for debugging
Price.displayName = "Price";
/* harmony default export */ var components_Price = (Price);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./components/elements/form/Radio/index.js
var Radio = __webpack_require__(87048);
// EXTERNAL MODULE: ./node_modules/lodash-es/capitalize.js
var capitalize = __webpack_require__(26786);
// EXTERNAL MODULE: ./node_modules/lodash-es/toLower.js
var toLower = __webpack_require__(94731);
// EXTERNAL MODULE: ./node_modules/lodash-es/lowerCase.js
var lowerCase = __webpack_require__(21618);
// EXTERNAL MODULE: ./components/configs/axios.js
var axios = __webpack_require__(92375);
// EXTERNAL MODULE: ./components/elements/DateSearch/components/HomeType/styles.module.scss
var HomeType_styles_module = __webpack_require__(57477);
var HomeType_styles_module_default = /*#__PURE__*/__webpack_require__.n(HomeType_styles_module);
// EXTERNAL MODULE: ./components/elements/Grid/index.js
var Grid = __webpack_require__(117);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
;// CONCATENATED MODULE: ./components/helpers/translate.js



var translate = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(text) {
        var locale, response, translatedText, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = _args.length > 1 && _args[1] !== void 0 ? _args[1] : "en";
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return axios_default().post(// 'http://localhost:3000/api/translate',
                    // eslint-disable-next-line no-undef
                    "".concat("https://sxmsir.com", "/api/translate"), null, {
                        params: {
                            text: text,
                            locale: locale
                        }
                    });
                case 4:
                    response = _ctx.sent;
                    translatedText = response.data.translation;
                    return _ctx.abrupt("return", translatedText);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](1);
                    console.error(_ctx.t0);
                    return _ctx.abrupt("return", text);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                9
            ]
        ]);
    }));
    return function translate(text) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/elements/DateSearch/components/HomeType/index.js





















var HomeType = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var setFieldValue = _param.form.setFieldValue, _target = _param.target, target = _target === void 0 ? "vacation-rentals" : _target, shadowRef = _param.shadowRef, setFiltersActive = _param.setFiltersActive, translations = _param.translations, props = (0,_object_without_properties/* default */.Z)(_param, [
        "form",
        "target",
        "shadowRef",
        "setFiltersActive",
        "translations"
    ]);
    var router = (0,next_router.useRouter)();
    var search = (0,SearchContext/* useSearchContext */.AB)().search;
    var ref = (0,react.useState)([]), additionalFields = ref[0], setAdditionalFields = ref[1];
    var ref1 = (0,ResponsiveContext/* useResponsive */.F)(), isSmallMobile = ref1.isSmallMobile, isMobile = ref1.isMobile;
    var wrapperRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), show = ref2[0], setShow = ref2[1];
    var ref3 = (0,react.useState)((search === null || search === void 0 ? void 0 : search.homeType) || []), checked = ref3[0], setChecked = ref3[1];
    var ref4 = (0,react.useState)((search === null || search === void 0 ? void 0 : search.amenities) || []), amenitiesChecked = ref4[0], setAmenitiesChecked = ref4[1];
    var ref5 = (0,react.useState)(false), dataLoaded = ref5[0], setDataLoaded = ref5[1];
    // Initial types with translations
    var ref6 = (0,react.useState)([
        {
            value: "exclusive",
            label: translations.exclusiveproperties[router.locale]
        },
        {
            value: "villa",
            label: translations.villas[router.locale]
        },
        {
            value: "condominium",
            label: translations.condos[router.locale]
        }
    ]), types = ref6[0], setTypes = ref6[1];
    // String utility for replacing hyphens with spaces
    var replaceInArray = (0,react.useCallback)(function(str) {
        return str && str.replace(/-/g, " ");
    }, []);
    var ref7 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(search.homeType)), label = ref7[0], setLabel = ref7[1];
    // Handle click outside
    var handleClickOutside = (0,react.useCallback)(function(event) {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShow(false);
        }
    }, []);
    // Set up click outside handler
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    // Submit changes to parent form and context
    (0,react.useEffect)(function() {
        setFieldValue("homeType", (0,_to_consumable_array/* default */.Z)(checked));
        setFieldValue("amenities", (0,_to_consumable_array/* default */.Z)(amenitiesChecked));
        if (!(0,isEmpty/* default */.Z)(checked) || !(0,isEmpty/* default */.Z)(amenitiesChecked)) {
            setLabel((0,_to_consumable_array/* default */.Z)(checked).concat([
                amenitiesChecked.map(replaceInArray).join(", ")
            ]));
        }
    }, [
        amenitiesChecked,
        checked
    ]);
    // Handle home type checkbox changes
    var handleChange = (0,react.useCallback)(function(e) {
        setChecked(function(prevChecked) {
            var updatedList = (0,_to_consumable_array/* default */.Z)(prevChecked);
            if (e.target.checked) {
                updatedList = (0,_to_consumable_array/* default */.Z)(prevChecked).concat([
                    e.target.value
                ]);
            } else {
                updatedList.splice(prevChecked.indexOf(e.target.value), 1);
            }
            return updatedList;
        });
    }, []);
    // Handle amenities checkbox changes
    var handleAmenitiesChange = (0,react.useCallback)(function(e) {
        setAmenitiesChecked(function(prevChecked) {
            var updatedList = (0,_to_consumable_array/* default */.Z)(prevChecked);
            if (e.target.checked) {
                updatedList = (0,_to_consumable_array/* default */.Z)(prevChecked).concat([
                    e.target.value
                ]);
            } else {
                updatedList.splice(prevChecked.indexOf(e.target.value), 1);
            }
            return updatedList;
        });
    }, []);
    // Format label text
    var labelFunction = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (router.locale !== "en" && "object" !== "undefined") {
                        if (!(0,isEmpty/* default */.Z)(search.amenities)) {
                            setLabel((0,_to_consumable_array/* default */.Z)(search.homeType).concat([
                                search.amenities.map(replaceInArray).join(", ")
                            ]));
                        } else {
                            setLabel((0,_to_consumable_array/* default */.Z)(search.homeType).concat([
                                search.amenities.map(replaceInArray).join(", ")
                            ]));
                        }
                    }
                    if (!((0,isEmpty/* default */.Z)(search.amenities) && !(0,isEmpty/* default */.Z)(search.homeType))) {
                        _ctx.next = 11;
                        break;
                    }
                    if (!(router.locale !== "en")) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.t0 = setLabel;
                    _ctx.next = 6;
                    return translate(search.homeType);
                case 6:
                    _ctx.t1 = _ctx.sent;
                    (0, _ctx.t0)(_ctx.t1);
                    _ctx.next = 11;
                    break;
                case 10:
                    {
                        setLabel(search.homeType);
                    }
                case 11:
                    if ((0,isEmpty/* default */.Z)(search.amenities) && (0,isEmpty/* default */.Z)(search.homeType)) {
                        setLabel(translations.filters[router.locale]);
                    }
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        search.amenities,
        search.homeType,
        router.locale,
        replaceInArray,
        translations
    ]);
    // Sync with search context
    (0,react.useEffect)(function() {
        labelFunction();
        setAmenitiesChecked((search === null || search === void 0 ? void 0 : search.amenities) || []);
        setChecked((search === null || search === void 0 ? void 0 : search.homeType) || []);
    }, [
        search.amenities,
        search.homeType,
        labelFunction
    ]);
    // Load property types for real estate
    (0,react.useEffect)(function() {
        if (target !== "vacation-rentals") {
            axios/* default.get */.Z.get("real-estate/property-type").then(function(res) {
                var realEstateTypes = res.data[router.locale].map(function(type) {
                    return {
                        value: (0,lowerCase/* default */.Z)(type).replace(" ", "-"),
                        label: type
                    };
                });
                setTypes([
                    {
                        value: "exclusive",
                        label: translations.exclusiveproperties[router.locale]
                    }
                ].concat((0,_to_consumable_array/* default */.Z)(realEstateTypes)));
            });
        }
    }, [
        router.locale,
        target,
        translations
    ]);
    // Load amenities
    (0,react.useEffect)(function() {
        var endpoint = target === "vacation-rentals" ? "amenities/tag" : "real-estate/popular-amenities";
        axios/* default.get */.Z.get(endpoint).then(function(res) {
            if (target === "vacation-rentals") {
                setAdditionalFields(res.data[router.locale]);
            } else {
                setAdditionalFields({
                    amenities: res.data[router.locale]
                });
            }
            setDataLoaded(true);
        }).catch(function(err) {
            return console.error(err);
        });
        setAmenitiesChecked((search === null || search === void 0 ? void 0 : search.amenities) || []);
    }, [
        router.locale,
        target,
        search === null || search === void 0 ? void 0 : search.amenities
    ]);
    // Submit when checkbox selections change
    // useEffect(() => {
    //   handleSubmit()
    // }, [checked, amenitiesChecked, handleSubmit])
    // Handle shadow overlay
    (0,react.useEffect)(function() {
        if (shadowRef) {
            if (show) {
                var ref;
                (ref = shadowRef.current) === null || ref === void 0 ? void 0 : ref.classList.add("isVisible");
            } else {
                var ref1;
                (ref1 = shadowRef.current) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("isVisible");
            }
        }
        if (setFiltersActive) {
            setFiltersActive(show || !(0,isEmpty/* default */.Z)(search.amenities) || !(0,isEmpty/* default */.Z)(search.homeType));
        }
    }, [
        shadowRef,
        show,
        search.amenities,
        search.homeType,
        setFiltersActive
    ]);
    // Toggle show/hide
    var toggleShow = (0,react.useCallback)(function() {
        setShow(function(prev) {
            return !prev;
        });
    }, []);
    // Track if filters content should be in DOM with a separate state
    var ref8 = (0,react.useState)(false), filtersMounted = ref8[0], setFiltersMounted = ref8[1];
    // Use effect to handle mounting/unmounting with proper timing for transitions
    (0,react.useEffect)(function() {
        if (show) {
            // When opening, mount content immediately
            setFiltersMounted(true);
        } else if (!show && filtersMounted) {
            // When closing, wait for transition to finish before unmounting
            var transitionDuration = 300 // Match this with your CSS transition duration
            ;
            var timer = setTimeout(function() {
                setFiltersMounted(false);
            }, transitionDuration);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        show,
        filtersMounted
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: wrapperRef,
        className: (HomeType_styles_module_default()).field,
        role: "group",
        "aria-labelledby": "bedrooms-group",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, (0,_object_spread/* default */.Z)({
                "aria-label": "Select Home Type",
                type: "text",
                readOnly: true,
                angle: true,
                variant: [
                    isMobile && "full-width"
                ],
                onClick: toggleShow,
                value: label,
                isActive: !(0,isEmpty/* default */.Z)(checked) || !(0,isEmpty/* default */.Z)(amenitiesChecked)
            }, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((HomeType_styles_module_default()).field__radios, show && (HomeType_styles_module_default()).isShown),
                children: filtersMounted && dataLoaded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (HomeType_styles_module_default()).filters,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (HomeType_styles_module_default()).filters__label,
                                    children: translations.homeType[router.locale]
                                }),
                                types.map(function(item, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                        name: "homeType",
                                        checkbox: true,
                                        value: item.value,
                                        label: item.label,
                                        checked: checked === null || checked === void 0 ? void 0 : checked.includes(item.value),
                                        onChange: handleChange,
                                        disabled: item.disabled
                                    }, "type-".concat(index));
                                })
                            ]
                        }),
                        !(0,isEmpty/* default */.Z)(additionalFields.amenities) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HomeType_styles_module_default()).filters__amenities,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (HomeType_styles_module_default()).filters__label,
                                    children: translations.amenities[router.locale]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    variant: [
                                        isSmallMobile ? "grid-2" : "rows-5",
                                        "rows-2xs"
                                    ],
                                    children: additionalFields.amenities.map(function(item, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                            variant: [
                                                "is-close",
                                                "small"
                                            ],
                                            name: "homeType",
                                            checkbox: true,
                                            value: (0,toLower/* default */.Z)(item),
                                            label: (0,capitalize/* default */.Z)(item),
                                            checked: amenitiesChecked === null || amenitiesChecked === void 0 ? void 0 : amenitiesChecked.includes((0,toLower/* default */.Z)(item)),
                                            onChange: handleAmenitiesChange,
                                            disabled: item.disabled
                                        }, "amenity-".concat(index));
                                    })
                                })
                            ]
                        }),
                        !(0,isEmpty/* default */.Z)(additionalFields.offers) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HomeType_styles_module_default()).filters__amenities,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (HomeType_styles_module_default()).filters__label,
                                    children: "Promos"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    variant: [
                                        isSmallMobile ? "grid-2" : "rows-5",
                                        "rows-2xs"
                                    ],
                                    children: additionalFields.offers.map(function(item, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                            variant: [
                                                "is-close",
                                                "small"
                                            ],
                                            name: "homeType",
                                            checkbox: true,
                                            value: (0,toLower/* default */.Z)(item),
                                            label: (0,capitalize/* default */.Z)(item),
                                            checked: amenitiesChecked === null || amenitiesChecked === void 0 ? void 0 : amenitiesChecked.includes((0,toLower/* default */.Z)(item)),
                                            onChange: handleAmenitiesChange,
                                            disabled: item.disabled
                                        }, "amenity-".concat(index));
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});
// Display name for debugging
HomeType.displayName = "HomeType";
/* harmony default export */ var components_HomeType = (HomeType);

// EXTERNAL MODULE: ./components/elements/DateSearch/components/Location/styles.module.scss
var Location_styles_module = __webpack_require__(37103);
var Location_styles_module_default = /*#__PURE__*/__webpack_require__.n(Location_styles_module);
;// CONCATENATED MODULE: ./public/icons/icon-location.svg
var icon_location_path, icon_location_path2;

function icon_location_extends() { icon_location_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_location_extends.apply(this, arguments); }



const SvgIconLocation = props => /*#__PURE__*/react.createElement("svg", icon_location_extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_location_path || (icon_location_path = /*#__PURE__*/react.createElement("path", {
  d: "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  stroke: "currentColor",
  strokeLinejoin: "round"
})), icon_location_path2 || (icon_location_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M12 22c4-4 8-7.582 8-12a8 8 0 1 0-16 0c0 4.418 4 8 8 12Z",
  stroke: "currentColor",
  strokeLinejoin: "round"
})));

/* harmony default export */ var icon_location = (SvgIconLocation);
;// CONCATENATED MODULE: ./components/elements/DateSearch/components/Location/index.js
















var Locations = function(param) {
    var setFieldValue = param.form.setFieldValue;
    // Get necessary context and router
    var ref = (0,SearchContext/* useSearchContext */.AB)(), search = ref.search, setSearch = ref.setSearch;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,ResponsiveContext/* useResponsive */.F)(), isMobile = ref1.isMobile, isTablet = ref1.isTablet, isSmallMobile = ref1.isSmallMobile;
    // Component state
    var ref2 = (0,react.useState)(search.location || []), checked = ref2[0], setChecked = ref2[1];
    var ref3 = (0,react.useState)(null), locations = ref3[0], setLocations = ref3[1];
    var ref4 = (0,react.useState)(false), show = ref4[0], setShow = ref4[1];
    var ref5 = (0,react.useState)(false), locationMounted = ref5[0], setLocationMounted = ref5[1];
    var ref6 = (0,react.useState)("Locations"), displayText = ref6[0], setDisplayText = ref6[1];
    // Refs
    var wrapperRef = (0,react.useRef)(null);
    var transitionTimerRef = (0,react.useRef)(null);
    // Helper function to replace hyphens with spaces
    var replaceInArray = (0,react.useCallback)(function(str) {
        return str.replace(/-/g, " ");
    }, []);
    // Load locations data based on route
    var loadLocations = (0,react.useCallback)(function() {
        var isRealEstate = router.pathname.includes("real-estate");
        var endpoint = isRealEstate ? "real-estate/neighbourhood" : "listings/neighbourhood";
        axios/* default.get */.Z.get(endpoint).then(function(res) {
            setLocations(res.data);
        }).catch(function(err) {
            return console.error(err);
        });
    }, [
        router.pathname
    ]);
    // Update label and checked state from search context
    var updateLabelFromSearch = (0,react.useCallback)(function() {
        if (!(0,isEmpty/* default */.Z)(search.location)) {
            setChecked(search.location);
            var formattedLabel = search.location.map(replaceInArray).join(", ");
            setDisplayText(formattedLabel);
        } else {
            setDisplayText("Locations");
        }
    }, [
        search.location,
        replaceInArray
    ]);
    // Handle checkbox change with inline submission
    var handleChange = (0,react.useCallback)(function(e) {
        setChecked(function(prevChecked) {
            var updatedList = (0,_to_consumable_array/* default */.Z)(prevChecked);
            if (e.target.checked) {
                updatedList = (0,_to_consumable_array/* default */.Z)(prevChecked).concat([
                    e.target.value
                ]);
            } else {
                updatedList.splice(prevChecked.indexOf(e.target.value), 1);
            }
            // Update form and context directly here instead of through useEffect
            setFieldValue("location", updatedList);
            setSearch(function(prevSearch) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevSearch), {
                    location: updatedList
                });
            });
            // Update label and display text
            if (!(0,isEmpty/* default */.Z)(updatedList)) {
                var formattedText = updatedList.map(replaceInArray).join(", ");
                setDisplayText(formattedText);
            } else {
                setDisplayText("Locations");
            }
            return updatedList;
        });
    }, [
        setFieldValue,
        setSearch,
        replaceInArray
    ]);
    // Toggle dropdown show/hide with proper transition handling
    var toggleShow = (0,react.useCallback)(function() {
        if (!show) {
            // Opening dropdown
            setShow(true);
            setLocationMounted(true);
        } else {
            // Closing dropdown
            setShow(false);
            // Wait for transition to finish before unmounting content
            if (transitionTimerRef.current) {
                clearTimeout(transitionTimerRef.current);
            }
            var transitionDuration = 300;
            transitionTimerRef.current = setTimeout(function() {
                setLocationMounted(false);
            }, transitionDuration);
        }
    }, [
        show
    ]);
    // Handle clicks outside the component
    var handleClickOutside = (0,react.useCallback)(function(event) {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target) && show) {
            toggleShow();
        }
    }, [
        show,
        toggleShow
    ]);
    // Initial setup - equivalent to componentDidMount
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        loadLocations();
        updateLabelFromSearch();
        // Cleanup - equivalent to componentWillUnmount
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
            if (transitionTimerRef.current) {
                clearTimeout(transitionTimerRef.current);
            }
        };
    }, [
        handleClickOutside,
        loadLocations,
        updateLabelFromSearch
    ]);
    // Watch for search context changes - equivalent to componentDidUpdate
    (0,react.useEffect)(function() {
        updateLabelFromSearch();
    }, [
        search,
        updateLabelFromSearch
    ]);
    // Don't render until data is loaded
    if (!locations) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                "aria-label": "Select Location",
                value: displayText,
                onClick: toggleShow,
                width: isTablet ? 6 : 9,
                prependIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_location, {
                    width: 26,
                    height: 26
                }),
                isActive: !(0,isEmpty/* default */.Z)(checked),
                variant: [
                    isMobile && "full-width"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Location_styles_module_default()).field, show && (Location_styles_module_default()).isShown),
                children: locationMounted && locations && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Location_styles_module_default()).location,
                    children: locations.map(function(item, index) {
                        return !(0,isEmpty/* default */.Z)(item.options) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Location_styles_module_default()).location__column,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Location_styles_module_default()).location__title,
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    variant: [
                                        isSmallMobile ? "grid-1" : isMobile ? "grid-2" : isTablet ? "grid-2" : item.options.length > 5 ? "rows-6" : "rows-5",
                                        "rows-2xs"
                                    ],
                                    children: item.options.map(function(radio, number) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                            name: "location",
                                            variant: [
                                                "is-close",
                                                "small"
                                            ],
                                            checkbox: true,
                                            value: radio.value,
                                            label: radio.label,
                                            checked: checked === null || checked === void 0 ? void 0 : checked.includes(radio.value),
                                            onChange: handleChange
                                        }, "".concat(index, "-").concat(number));
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Location = (Locations);

;// CONCATENATED MODULE: ./components/elements/DateSearch/index.js


















// Import components directly to avoid issues with dynamic imports





var DateSearch = function(param) {
    var _optional = param.optional, optional = _optional === void 0 ? false : _optional, _custom = param.custom, custom = _custom === void 0 ? false : _custom, shadowRef = param.shadowRef, setIsActive = param.setIsActive, button = param.button, price = param.price, _target = param.target, target = _target === void 0 ? "vacation-rentals" : _target, form = param.form, translations = param.translations;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,SearchContext/* useSearchContext */.AB)(), search = ref1.search, setSearch = ref1.setSearch, reset = ref1.reset, initialValues = ref1.initialValues, setSearchActive = ref1.setSearchActive, setOffsetable = ref1.setOffsetable;
    // State management - reduced number of state variables
    var ref2 = (0,react.useState)({
        prepend: (translations === null || translations === void 0 ? void 0 : (ref = translations.listing) === null || ref === void 0 ? void 0 : ref[router.locale]) || "",
        listing: (search === null || search === void 0 ? void 0 : search.listing) || "",
        priceActive: false,
        calendarActive: false,
        bedroomActive: false,
        listingActive: false,
        filtersActive: false,
        searchedUrl: "vacation-rentals"
    }), uiState = ref2[0], setUiState = ref2[1];
    // Single reference for all active states to reduce re-renders
    var prepend = uiState.prepend, listing = uiState.listing;
    // Refs to prevent unnecessary re-renders
    var isFirstRender = (0,react.useRef)(true);
    var routerPathRef = (0,react.useRef)(router.asPath);
    var activeStateRef = (0,react.useRef)({});
    var fieldsCache = (0,react.useRef)({});
    var ref3 = (0,ResponsiveContext/* useResponsive */.F)(), isMobile = ref3.isMobile, isTablet = ref3.isTablet;
    // Memoize form initial values
    var formInitialValues = (0,react.useMemo)(function() {
        return {
            startDate: initialValues.startDate,
            endDate: initialValues.endDate,
            bedrooms: initialValues.bedrooms,
            listing: initialValues.listing,
            homeType: initialValues.homeType,
            amenities: initialValues.amenities,
            priceStart: initialValues.priceStart,
            priceEnd: initialValues.priceEnd,
            location: initialValues.location
        };
    }, [] // Empty deps array - only compute once on initial render
    );
    // Handlers with useCallback to avoid recreating functions
    var updateUiState = (0,react.useCallback)(function(updates) {
        setUiState(function(prev) {
            return (0,_object_spread/* default */.Z)({}, prev, updates);
        });
    }, []);
    var handleVacationSearch = (0,react.useCallback)(function() {
        if (setSearchActive && target === "vacation-rentals") {
            setSearchActive(true);
        }
        updateUiState({
            searchedUrl: "vacation-rentals"
        });
    }, [
        setSearchActive,
        target,
        updateUiState
    ]);
    var handleRealEstateSearch = (0,react.useCallback)(function() {
        updateUiState({
            searchedUrl: "real-estate"
        });
        if (setSearchActive && target !== "vacation-rentals") {
            setSearchActive(true);
        }
    }, [
        setSearchActive,
        target,
        updateUiState
    ]);
    var handleSubmit = (0,react.useCallback)(function(values, param) {
        var setSubmitting = param.setSubmitting;
        var ref, ref1;
        setSubmitting(true);
        // Update the search state based on priceActive flag
        var newSearchValues = uiState.priceActive ? (0,_object_spread/* default */.Z)({}, initialValues, values) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialValues, values), {
            startDate: ((ref = values.startDate) === null || ref === void 0 ? void 0 : ref.toISOString()) || null,
            endDate: ((ref1 = values.endDate) === null || ref1 === void 0 ? void 0 : ref1.toISOString()) || null,
            listing: values.listing === "" ? null : values.listing,
            priceStart: null,
            priceEnd: null
        });
        // Determine route based on target and searchedUrl
        var reroute = uiState.searchedUrl !== "vacation-rentals" ? "/real-estate/search" : target === "vacation-rentals" ? "/".concat(target) : "/".concat(target, "/search");
        // Filter out null values for query params
        var filteredParams = Object.fromEntries(Object.entries(newSearchValues).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            return value != null && !(key === "sorting" && value === "default");
        }));
        // Use router.push with shallow routing when appropriate
        router.push({
            pathname: reroute,
            query: filteredParams,
            shallow: router.pathname === reroute
        }, undefined, {
            shallow: router.pathname === reroute
        });
        setSubmitting(false);
    }, [
        uiState.priceActive,
        uiState.searchedUrl,
        initialValues,
        target,
        router
    ]);
    // Update active state ref to avoid excessive re-renders
    (0,react.useEffect)(function() {
        activeStateRef.current = {
            calendarActive: uiState.calendarActive,
            bedroomActive: uiState.bedroomActive,
            listingActive: uiState.listingActive,
            priceActive: uiState.priceActive,
            filtersActive: uiState.filtersActive
        };
        // Notify parent of active state
        if (setIsActive) {
            var isAnyFieldActive = Object.values(activeStateRef.current).some(function(value) {
                return value;
            });
            setIsActive(isAnyFieldActive);
        }
    }, [
        uiState.calendarActive,
        uiState.bedroomActive,
        uiState.listingActive,
        uiState.priceActive,
        uiState.filtersActive,
        setIsActive
    ]);
    // Handle homepage reset - preserve dates when navigating between home and vacation-rentals
    (0,react.useEffect)(function() {
        var currentPath = router.asPath;
        var prevPath = routerPathRef.current;
        // Only run this if we're newly navigating to the homepage
        // Preserve dates when navigating between home and vacation-rentals
        if (currentPath === "/" && prevPath !== "/" && currentPath !== prevPath) {
            var isFromVacationRentals = prevPath === "/vacation-rentals" || prevPath.startsWith("/vacation-rentals");
            if (isFromVacationRentals) {
                // Preserve dates when navigating from vacation-rentals to home
                setSearch(function(prevSearch) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialValues), {
                        startDate: prevSearch.startDate,
                        endDate: prevSearch.endDate
                    });
                });
            } else {
                // Reset everything when navigating from other pages
                setSearch(initialValues);
            }
            setOffsetable(0);
        }
        // Update ref with latest path
        routerPathRef.current = currentPath;
    }, [
        router.asPath,
        initialValues,
        setSearch,
        setOffsetable
    ]);
    // Handle locale changes and reset
    (0,react.useEffect)(function() {
        var ref;
        var newPrepend = (translations === null || translations === void 0 ? void 0 : (ref = translations.listing) === null || ref === void 0 ? void 0 : ref[router.locale]) || "";
        // Update prepend on reset or locale change if needed
        if (reset || !listing && prepend !== newPrepend) {
            updateUiState({
                listing: reset ? initialValues.listing : listing,
                prepend: newPrepend
            });
        }
    }, [
        router.locale,
        translations,
        reset,
        initialValues.listing,
        listing,
        prepend,
        updateUiState
    ]);
    // Pre-render field components to avoid re-creation on each render
    var renderField = (0,react.useCallback)(function(field, index, values, setFieldValue) {
        // Use cached field if available to prevent re-renders
        var cacheKey = "".concat(field, "-").concat(index);
        // Only create new component if not cached or values changed
        if (!fieldsCache.current[cacheKey] || values !== fieldsCache.current["".concat(cacheKey, "-values")]) {
            var commonProps = {
                key: "field-".concat(index),
                values: values,
                shadowRef: shadowRef,
                translations: translations
            };
            var component;
            switch(field){
                case "homeType":
                    {
                        component = /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonProps), {
                            component: components_HomeType,
                            target: target,
                            prependIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_homeType, {
                                width: 26,
                                height: 24
                            }),
                            width: isTablet ? 7.1 : 9,
                            setFiltersActive: function(active) {
                                return updateUiState({
                                    filtersActive: active
                                });
                            }
                        }));
                        break;
                    }
                case "priceRange":
                    {
                        if (price) {
                            var ref;
                            component = /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonProps), {
                                component: components_Price,
                                price: price,
                                translation: translations === null || translations === void 0 ? void 0 : (ref = translations.priceRange) === null || ref === void 0 ? void 0 : ref[router.locale],
                                prependIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_price_range, {
                                    width: 26,
                                    height: 24
                                }),
                                width: isTablet ? 8 : 11,
                                setPriceActive: function(active) {
                                    return updateUiState({
                                        priceActive: active
                                    });
                                }
                            }));
                        }
                        break;
                    }
                case "dates":
                    {
                        component = /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonProps), {
                            setFieldValue: setFieldValue,
                            component: components_Dates,
                            custom: custom,
                            icon: true,
                            width: isTablet ? 14 : 20,
                            setCalendarActive: function(active) {
                                return updateUiState({
                                    calendarActive: active
                                });
                            }
                        }));
                        break;
                    }
                case "location":
                    {
                        component = /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonProps), {
                            setFieldValue: setFieldValue,
                            component: Location,
                            custom: custom,
                            icon: true,
                            setCalendarActive: function(active) {
                                return updateUiState({
                                    calendarActive: active
                                });
                            }
                        }));
                        break;
                    }
                case "bedrooms":
                    {
                        component = /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonProps), {
                            setFieldValue: setFieldValue,
                            component: components_Bedrooms,
                            custom: custom,
                            icon: true,
                            width: isTablet ? 7.8 : 11,
                            setBedroomActive: function(active) {
                                return updateUiState({
                                    bedroomActive: active
                                });
                            }
                        }));
                        break;
                    }
                case "listings":
                    {
                        component = /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomField/* default */.Z, {
                            "aria-label": "Search listing by name",
                            name: "listing",
                            prependIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_listing, {
                                width: 26,
                                height: 26
                            }),
                            type: "text",
                            width: listing !== "" ? isTablet ? 5 : 12.93 : isTablet ? 5 : 10.876,
                            variant: [
                                isMobile && "full-width",
                                "optional"
                            ],
                            translations: translations,
                            optional: optional,
                            value: listing,
                            onChange: function(e) {
                                setFieldValue("listing", e.target.value);
                                updateUiState({
                                    listing: e.target.value,
                                    listingActive: e.target.value !== ""
                                });
                            },
                            isActive: listing !== "",
                            prepend: prepend,
                            onFocus: function() {
                                updateUiState({
                                    prepend: ""
                                });
                            },
                            onBlur: function() {
                                if (listing === "") {
                                    var ref;
                                    updateUiState({
                                        prepend: (translations === null || translations === void 0 ? void 0 : (ref = translations.listing) === null || ref === void 0 ? void 0 : ref[router.locale]) || ""
                                    });
                                }
                            }
                        }, "field-".concat(index));
                        break;
                    }
            }
            if (component) {
                fieldsCache.current[cacheKey] = component;
                fieldsCache.current["".concat(cacheKey, "-values")] = values;
            }
        }
        return fieldsCache.current[cacheKey] || null;
    }, [
        shadowRef,
        target,
        translations,
        isTablet,
        price,
        router.locale,
        custom,
        isMobile,
        optional,
        listing,
        prepend,
        updateUiState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((styles_module_default()).search, custom ? (styles_module_default()).custom : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
            initialValues: formInitialValues,
            onSubmit: handleSubmit,
            enableReinitialize: false,
            children: function(param) {
                var values = param.values, setFieldValue = param.setFieldValue;
                var ref, ref1;
                // Calculate button active state once
                var buttonActive = (0,react.useMemo)(function() {
                    return values.bedrooms || values.startDate || values.endDate || values.listing !== "" || !(0,isEmpty/* default */.Z)(values.homeType) || !(0,isEmpty/* default */.Z)(values.location) || values.priceStart && values.priceStart !== 0 || values.priceEnd && values.priceEnd !== price || !(0,isEmpty/* default */.Z)(values.amenities);
                }, [
                    values,
                    price
                ]);
                // Handle search context updates via effect
                (0,react.useEffect)(function() {
                    if ((search === null || search === void 0 ? void 0 : search.listing) !== listing) {
                        var ref;
                        setFieldValue("listing", search.listing);
                        updateUiState({
                            listing: search.listing,
                            prepend: search.listing ? "" : (translations === null || translations === void 0 ? void 0 : (ref = translations.listing) === null || ref === void 0 ? void 0 : ref[router.locale]) || ""
                        });
                    }
                }, [
                    search.listing
                ]) // Only depend on search.listing
                ;
                // Handle form mounting once
                (0,react.useEffect)(function() {
                    if (isFirstRender.current) {
                        isFirstRender.current = false;
                    }
                }, []);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                    className: (styles_module_default()).form,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).wrapper,
                            children: [
                                form === null || form === void 0 ? void 0 : form.map(function(field, index) {
                                    return renderField(field, index, values, setFieldValue);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                    variant: [
                                        "xs",
                                        "secondary",
                                        "gold",
                                        "-offset-right",
                                        isMobile && "full-width"
                                    ],
                                    onClick: handleVacationSearch,
                                    className: (0,withModifiers/* withModifiers */.i)("submit", [
                                        !buttonActive && "disabled"
                                    ], (styles_module_default())),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (styles_module_default()).submit__label,
                                        children: translations === null || translations === void 0 ? void 0 : (ref = translations.search) === null || ref === void 0 ? void 0 : ref[router.locale]
                                    })
                                })
                            ]
                        }),
                        button && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                            className: (styles_module_default()).button,
                            variant: [
                                "secondary"
                            ],
                            onClick: handleRealEstateSearch,
                            children: translations === null || translations === void 0 ? void 0 : (ref1 = translations.buyOrSell) === null || ref1 === void 0 ? void 0 : ref1[router.locale]
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ var elements_DateSearch = (/*#__PURE__*/react.memo(DateSearch));


/***/ }),

/***/ 44576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63714);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _public_icons_dropdown_caret_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57827);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41197);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34495);










var Dropdown = function(_param) {
    var children = _param.children, title = _param.title, _arrow = _param.arrow, arrow = _arrow === void 0 ? true : _arrow, _custom = _param.custom, custom = _custom === void 0 ? false : _custom, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _active = _param.active, active = _active === void 0 ? false : _active, _handleClose = _param.handleClose, handleClose = _handleClose === void 0 ? false : _handleClose, _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, _buttonVariant = _param.buttonVariant, buttonVariant = _buttonVariant === void 0 ? [] : _buttonVariant, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "title",
        "arrow",
        "custom",
        "disabled",
        "active",
        "handleClose",
        "variant",
        "buttonVariant"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), width = ref1[0], setWidth = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), shouldRender = ref2[0], setShouldRender = ref2[1];
    var contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var isTouch =  true && (window === null || window === void 0 ? void 0 : window.matchMedia("(pointer: coarse)").matches);
    var handleOpen = function() {
        setOpen(!open);
        setShouldRender(true);
        setTimeout(function() {
            var ref;
            !open && ((ref = contentRef.current) === null || ref === void 0 ? void 0 : ref.focus());
        }, 100);
    };
    var handleMouseEnter = function() {
        if (!isTouch && !disabled) {
            setOpen(true);
            setShouldRender(true);
        }
    };
    var handleMouseLeave = function() {
        if (!isTouch) {
            setOpen(false);
            timeoutRef.current = setTimeout(function() {
                setShouldRender(false);
            }, 200);
        }
    };
    // Keyboard accessibility
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var keyDownHandler = function(event) {
            if (event.key === "Enter" && document.activeElement === buttonRef.current) {
                event.preventDefault();
                setOpen(true);
                setShouldRender(true);
            }
        };
        document.addEventListener("keydown", keyDownHandler);
        return function() {
            document.removeEventListener("keydown", keyDownHandler);
        };
    }, []);
    // Positioning logic
    var positionDropdown = function() {
        var centeredElement = wrapperRef.current;
        var buttonElement = buttonRef.current;
        if (!centeredElement) return;
        var buttonRect = buttonElement.getBoundingClientRect();
        var centeredElementRect = centeredElement.getBoundingClientRect();
        var elementWidth = centeredElement.offsetWidth;
        var viewportWidth = window.innerWidth;
        if (centeredElementRect.right === viewportWidth + 2 && centeredElementRect.left !== 0 || centeredElementRect.left < 0 || centeredElementRect.right > viewportWidth) {
            if (elementWidth + elementWidth / 2 > viewportWidth || buttonRect.right + elementWidth / 2 > viewportWidth) {
                if (buttonRect.left < elementWidth / 2) {
                    centeredElement.style.left = "-".concat(buttonRect.left - 2, "px");
                    centeredElement.style.transform = "none";
                    centeredElement.style.right = "unset";
                }
                if (viewportWidth - buttonRect.right < elementWidth / 2 && getComputedStyle(centeredElement).getPropertyValue("transform") !== "none") {
                    centeredElement.style.right = "-".concat(viewportWidth - buttonRect.right - 20, "px");
                    centeredElement.style.left = "unset";
                    centeredElement.style.transform = "none";
                }
            }
        }
    };
    // Handle external close
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (handleClose) {
            setOpen(false);
            timeoutRef.current = setTimeout(function() {
                setShouldRender(false);
            }, 200);
        }
    }, [
        handleClose
    ]);
    // Positioning effect
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (shouldRender) {
            positionDropdown();
        }
    }, [
        shouldRender
    ]);
    // Resize observer
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (shouldRender && wrapperRef.current) {
            var observer = new ResizeObserver(function(entries) {
                setWidth(entries[0].contentRect.width);
            });
            var currentRef = wrapperRef.current // Store reference
            ;
            observer.observe(currentRef);
            return function() {
                if (currentRef) {
                    observer.unobserve(currentRef);
                }
            };
        }
    }, [
        shouldRender
    ]);
    // Cleanup timeout
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_5__/* .withModifiers */ .i)("dropdown", [
            custom ? "custom" : "",
            active && "is-active",
            open && "is-open",
            disabled && "disabled"
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(variant)), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default())),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button__WEBPACK_IMPORTED_MODULE_3__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                buttonRef: buttonRef,
                disabled: disabled,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().dropdown__button),
                onClick: function() {
                    if (isTouch || !open) {
                        handleOpen();
                    }
                },
                variant: [
                    "label"
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(buttonVariant)),
                arrow: false
            }, props), {
                children: [
                    title,
                    arrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_icons_dropdown_caret_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().dropdown__caret)
                    })
                ]
            })),
            shouldRender && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                width: width,
                ref: wrapperRef,
                className: "".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().dropdown__wrapper), " ").concat(open ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().open) : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: contentRef,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().dropdown__content),
                    children: children
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dropdown);


/***/ }),

/***/ 117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable react/prop-types */ 


var Grid = function(param) {
    var children = param.children, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default().apply(void 0, [
            "grid",
            className
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(variant))),
        children: [
            " ",
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Grid);


/***/ }),

/***/ 56375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ form_CustomField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 1 modules
var formik_esm = __webpack_require__(64636);
// EXTERNAL MODULE: ./components/elements/form/CustomField/styles.module.scss
var styles_module = __webpack_require__(58621);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-calendar-caret.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconCalendarCaret = props => /*#__PURE__*/react.createElement("svg", _extends({
  viewBox: "0 0 16 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "m15 1.433-7 6-7-6",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var icon_calendar_caret = (SvgIconCalendarCaret);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
;// CONCATENATED MODULE: ./components/elements/form/CustomField/index.js











var CustomField = function(_param) {
    var angle = _param.angle, prependIcon = _param.prependIcon, appendIcon = _param.appendIcon, _optional = _param.optional, optional = _optional === void 0 ? false : _optional, isActive = _param.isActive, prepend = _param.prepend, width = _param.width, _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, children = _param.children, label = _param.label, className = _param.className, error = _param.error, valid = _param.valid, _withError = _param.withError, withError = _withError === void 0 ? false : _withError, _formik = _param.formik, formik = _formik === void 0 ? true : _formik, props = (0,_object_without_properties/* default */.Z)(_param, [
        "angle",
        "prependIcon",
        "appendIcon",
        "optional",
        "isActive",
        "prepend",
        "width",
        "variant",
        "children",
        "label",
        "className",
        "error",
        "valid",
        "withError",
        "formik"
    ]);
    var ref, ref1, ref2;
    var ref3 = (0,react.useRef)(null);
    var icons = (0,react.useRef)(null);
    var ref4 = (0,react.useState)(0), padding = ref4[0], setPadding = ref4[1];
    var isTablet = (0,ResponsiveContext/* useResponsive */.F)().isTablet;
    (0,react.useEffect)(function() {
        var ref;
        setPadding((ref = ref3.current) === null || ref === void 0 ? void 0 : ref.offsetWidth);
    }, [
        ref3,
        prepend
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: optional && variant.includes("optional") ? {
            marginBottom: isTablet ? "0.8rem" : "1.1rem"
        } : undefined,
        className: classnames_default()(className, (0,withModifiers/* withModifiers */.i)("field", variant, (styles_module_default()))),
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: props.id || props.name,
                style: {
                    opacity: props.disabled ? 0.5 : 1
                },
                className: (styles_module_default()).field__label,
                children: label
            }),
            formik ? props.as === "select" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                id: props.id || props.name,
                className: (0,withModifiers/* withModifiers */.i)("field__input", [
                    isActive && "is-active"
                ], (styles_module_default()))
            }, props), {
                style: {
                    paddingLeft: appendIcon ? variant.includes("simple") ? "33px" : "42px" : prepend && "".concat(padding + 15, "px"),
                    width: !variant.includes("full-width") && width ? "".concat(width, "rem") : undefined,
                    paddingRight: icons ? ((ref = icons.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) + 12 : undefined
                },
                children: children
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                id: props.id || props.name,
                className: (0,withModifiers/* withModifiers */.i)("field__input", [
                    isActive && "is-active",
                    error && "error",
                    valid && "valid"
                ], (styles_module_default()))
            }, props), {
                style: {
                    paddingLeft: appendIcon ? variant.includes("simple") ? "33px" : "42px" : prepend && "".concat(padding + 15, "px"),
                    width: !variant.includes("full-width") && width ? "".concat(width, "rem") : undefined,
                    paddingRight: icons ? (((ref1 = icons.current) === null || ref1 === void 0 ? void 0 : ref1.offsetWidth) || 0) + 12 : undefined
                }
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (0,withModifiers/* withModifiers */.i)("field__input", [
                    isActive && "is-active",
                    error && "error",
                    valid && "valid"
                ], (styles_module_default())),
                id: props.id || props.name
            }, props), {
                style: {
                    paddingLeft: appendIcon ? variant.includes("simple") ? "33px" : "42px" : prepend && "".concat(padding + 15, "px"),
                    width: !variant.includes("full-width") && width ? "".concat(width, "rem") : undefined,
                    paddingRight: icons ? (((ref2 = icons.current) === null || ref2 === void 0 ? void 0 : ref2.offsetWidth) || 0) + 12 : undefined
                }
            })),
            appendIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).field__apend,
                children: appendIcon
            }),
            prepend && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref3,
                className: (styles_module_default()).field__prepend,
                children: prepend
            }),
            (angle || prependIcon) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: icons,
                className: (styles_module_default()).field__icons,
                children: [
                    prependIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).field__icon,
                        children: prependIcon
                    }),
                    angle && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_calendar_caret, {
                        className: (styles_module_default()).field__angle
                    })
                ]
            }),
            optional && variant.includes("optional") && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (styles_module_default()).field__optional,
                children: "* Optional"
            }),
            props.as !== "select" && children,
            (variant.includes("underline") || withError) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* ErrorMessage */.Bc, {
                    name: props.name,
                    children: function(msg) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).field__error,
                            children: msg
                        });
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var form_CustomField = (CustomField);


/***/ }),

/***/ 87048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64636);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26384);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34495);
/* harmony import */ var _public_icons_icon_checkbox_check_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73553);






var Radio = function(param) {
    var checked = param.checked, value = param.value, label = param.label, name = param.name, onChange = param.onChange, onClick = param.onClick, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, _checkbox = param.checkbox, checkbox = _checkbox === void 0 ? false : _checkbox, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var isWhite = variant.includes("white");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_3__/* .withModifiers */ .i)("radio", (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(variant).concat([
            disabled && "disabled"
        ]), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default())),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
                checked: checked,
                type: checkbox ? "checkbox" : "radio",
                name: name,
                value: value,
                disabled: disabled,
                onChange: onChange && onChange,
                onClick: onClick && onClick
            }),
            !variant.includes("boxed") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().radio__checkmark),
                children: isWhite && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_icons_icon_checkbox_check_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    width: 15,
                    height: 13
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().radio__label),
                children: label
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Radio);


/***/ }),

/***/ 34495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ withModifiers; }
/* harmony export */ });
var withModifiers = function(base, modifiers, styles) {
    var classNames = styles[base];
    if (!modifiers || !Array.isArray(modifiers) || 0 === modifiers.length) {
        return classNames;
    }
    modifiers.forEach(function(modifier) {
        if (styles[base + "--" + modifier]) {
            classNames += " " + styles[base + "--" + modifier];
        }
    });
    return classNames;
};


/***/ }),

/***/ 70539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable react/prop-types */ 


var Column = function(param) {
    var children = param.children, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, spans = param.spans, className = param.className, style = param.style, columnRef = param.columnRef;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: style,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default().apply(void 0, [
            "column",
            className
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(variant), [
            spans && "-spans-".concat(spans)
        ])),
        ref: columnRef,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Column);


/***/ }),

/***/ 40050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable react/prop-types */ 


var Columns = function(param) {
    var children = param.children, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, className = param.className, columnRef = param.columnRef;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default().apply(void 0, [
            "columns",
            className
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(variant))),
        ref: columnRef,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Columns);


/***/ }),

/***/ 51904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ templates_Page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/elements/Dropdown/index.js
var Dropdown = __webpack_require__(44576);
// EXTERNAL MODULE: ./components/general/Header/components/Bar/styles.module.scss
var styles_module = __webpack_require__(65458);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./public/icons/icon-favourite.svg
var icon_favourite = __webpack_require__(92562);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 1 modules
var formik_esm = __webpack_require__(64636);
// EXTERNAL MODULE: ./components/general/Header/components/Bar/components/styles.module.scss
var components_styles_module = __webpack_require__(26670);
var components_styles_module_default = /*#__PURE__*/__webpack_require__.n(components_styles_module);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./components/elements/form/Radio/index.js
var Radio = __webpack_require__(87048);
// EXTERNAL MODULE: ./providers/currencyProvider.js
var currencyProvider = __webpack_require__(4404);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/general/Header/components/Bar/components/Currency/index.js








var Currency = function(param) {
    var setCloseClick = param.setCloseClick, translation = param.translation;
    var ref = (0,currencyProvider/* useCurrencyContext */.VT)(), currency = ref.currency, setCurrency = ref.setCurrency, currencies = ref.currencies, defaultValue = ref.defaultValue;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(currency), checked = ref1[0], setChecked = ref1[1];
    var handleChange = function(e, setFieldValue) {
        setChecked(e.target.value);
        setFieldValue("currency", e.target.value);
    };
    var executeHide = function() {
        setCloseClick(true);
        setTimeout(function() {
            return setCloseClick(false);
        }, 20);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            currency: ""
        },
        onSubmit: function(values, param) {
            var setSubmitting = param.setSubmitting;
            setSubmitting(true);
            setCurrency(values.currency);
            setSubmitting(false);
        },
        children: function(param) {
            var setFieldValue = param.setFieldValue;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (components_styles_module_default()).form,
                        role: "group",
                        "aria-labelledby": "currency-group",
                        children: currencies.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                name: "currency",
                                value: item.value,
                                label: item.label,
                                checked: checked === item.value,
                                onChange: function(e) {
                                    return handleChange(e, setFieldValue);
                                }
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (components_styles_module_default()).form__footer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                disabled: currency === defaultValue,
                                variant: [
                                    "secondary",
                                    "xs",
                                    "-offset-left"
                                ],
                                onClick: function() {
                                    setChecked(defaultValue);
                                    setCurrency(defaultValue);
                                    executeHide();
                                },
                                arrow: false,
                                type: "reset",
                                children: translation === null || translation === void 0 ? void 0 : translation.clear[router.locale]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                arrow: false,
                                variant: [
                                    "xs"
                                ],
                                disabled: checked === currency,
                                type: "submit",
                                onClick: function() {
                                    return executeHide();
                                },
                                children: translation === null || translation === void 0 ? void 0 : translation.apply[router.locale]
                            })
                        ]
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var components_Currency = (Currency);

// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
;// CONCATENATED MODULE: ./public/icons/icon-phone.svg
var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconPhone = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 17,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M13.047.926H10.3c-1.629 0-2.954 1.339-2.954 2.984v4.768a.21.21 0 0 0 .207.21.208.208 0 0 0 .13-.046l2.408-1.95h2.955C14.675 6.893 16 5.555 16 3.91 16 2.265 14.675.926 13.047.926Zm0 5.548H8.706a.208.208 0 0 0-.208.21c0 .115.093.209.207.209h.723L7.76 8.243V3.91c0-1.414 1.14-2.565 2.54-2.565h2.746c1.4 0 2.54 1.15 2.54 2.565 0 1.413-1.14 2.564-2.54 2.564Z",
  fill: "#B18D3B",
  stroke: "#B18D3B",
  strokeWidth: 0.3
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M13.997 2.933H9.35a.208.208 0 0 0-.208.209c0 .116.093.21.208.21h4.647a.208.208 0 0 0 .207-.21.208.208 0 0 0-.207-.21ZM13.306 4.698H10.04a.208.208 0 0 0-.207.21c0 .115.092.209.207.209h3.266a.208.208 0 0 0 .208-.21.209.209 0 0 0-.208-.209Z",
  fill: "#B18D3B",
  stroke: "#B18D3B",
  strokeWidth: 0.3
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M6.958 9.901a.205.205 0 0 0-.268.002l-1.27 1.1c-.903-.81-1.534-2.342-1.586-3.848l1.455-.05a.208.208 0 0 0 .2-.186l.37-3.218a.21.21 0 0 0-.11-.21l-2.48-1.306a.206.206 0 0 0-.248.042A7.55 7.55 0 0 0 1 7.387c0 4.157 3.35 7.54 7.466 7.54.091 0 .172-.061.198-.15l.78-2.621a.21.21 0 0 0-.066-.222l-2.42-2.033Zm1.354 4.605c-3.818-.083-6.898-3.245-6.898-7.12 0-1.765.64-3.447 1.804-4.756L5.43 3.795l-.333 2.896-1.482.052a.209.209 0 0 0-.2.21c0 1.76.772 3.605 1.877 4.488.078.063.189.06.264-.005l1.271-1.1 2.18 1.831-.696 2.34Z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.3
})));

/* harmony default export */ var icon_phone = (SvgIconPhone);
;// CONCATENATED MODULE: ./public/icons/flags/ES.svg
var _rect, _rect2, _g;

function ES_extends() { ES_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ES_extends.apply(this, arguments); }



const SvgEs = props => /*#__PURE__*/react.createElement("svg", ES_extends({
  viewBox: "0 0 28 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
  width: 28,
  height: 20,
  rx: 2,
  fill: "#fff"
})), /*#__PURE__*/react.createElement("mask", {
  id: "ES_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 28,
  height: 20
}, _rect2 || (_rect2 = /*#__PURE__*/react.createElement("rect", {
  width: 28,
  height: 20,
  rx: 2,
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/react.createElement("g", {
  mask: "url(#ES_svg__a)"
}, /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 5.333h28V0H0v5.333ZM0 20h28v-5.333H0V20Z",
  fill: "#DD172C"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 14.667h28V5.333H0v9.334Z",
  fill: "#FFD133"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.333 9.333h1.334V10H7.333v-.667Z",
  fill: "#FFEDB1"
}), /*#__PURE__*/react.createElement("path", {
  d: "M6.059 9.361A.333.333 0 0 1 6.391 9h1.884c.195 0 .349.167.333.361l-.172 2.055a1 1 0 0 1-.996.917h-.213a1 1 0 0 1-.997-.917L6.06 9.361Z",
  stroke: "#A41517",
  strokeWidth: 0.667
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 10h2.667v.667H8L7.333 12l-.666-1.333H6V10Z",
  fill: "#A41517"
}), /*#__PURE__*/react.createElement("rect", {
  x: 4,
  y: 8,
  width: 1.333,
  height: 4.667,
  rx: 0.667,
  fill: "#A41517"
}), /*#__PURE__*/react.createElement("rect", {
  x: 9.333,
  y: 8,
  width: 1.333,
  height: 4.667,
  rx: 0.667,
  fill: "#A41517"
}), /*#__PURE__*/react.createElement("path", {
  d: "M6 7.733c0-.589.478-1.066 1.067-1.066H7.6c.59 0 1.067.477 1.067 1.066 0 .148-.12.267-.267.267H6.267A.267.267 0 0 1 6 7.733Z",
  fill: "#A41517"
}))));

/* harmony default export */ var ES = (SvgEs);
;// CONCATENATED MODULE: ./public/icons/flags/FR.svg
var FR_rect, FR_rect2, FR_g;

function FR_extends() { FR_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FR_extends.apply(this, arguments); }



const SvgFr = props => /*#__PURE__*/react.createElement("svg", FR_extends({
  viewBox: "0 0 28 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), FR_rect || (FR_rect = /*#__PURE__*/react.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 27.5,
  height: 19.5,
  rx: 1.75,
  fill: "#fff",
  stroke: "#F5F5F5",
  strokeWidth: 0.5
})), /*#__PURE__*/react.createElement("mask", {
  id: "FR_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 28,
  height: 20
}, FR_rect2 || (FR_rect2 = /*#__PURE__*/react.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 27.5,
  height: 19.5,
  rx: 1.75,
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}))), FR_g || (FR_g = /*#__PURE__*/react.createElement("g", {
  mask: "url(#FR_svg__a)"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#F44653",
  d: "M18.667 0H28v20h-9.333z"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 20h9.333V0H0v20Z",
  fill: "#1035BB"
}))));

/* harmony default export */ var FR = (SvgFr);
;// CONCATENATED MODULE: ./public/icons/flags/US.svg
var US_rect, US_rect2, US_g, _defs;

function US_extends() { US_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return US_extends.apply(this, arguments); }



const SvgUs = props => /*#__PURE__*/react.createElement("svg", US_extends({
  viewBox: "0 0 28 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), US_rect || (US_rect = /*#__PURE__*/react.createElement("rect", {
  width: 28,
  height: 20,
  rx: 2,
  fill: "#fff"
})), /*#__PURE__*/react.createElement("mask", {
  id: "US_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 28,
  height: 20
}, US_rect2 || (US_rect2 = /*#__PURE__*/react.createElement("rect", {
  width: 28,
  height: 20,
  rx: 2,
  fill: "#fff"
}))), US_g || (US_g = /*#__PURE__*/react.createElement("g", {
  mask: "url(#US_svg__a)"
}, /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28 0H0v1.333h28V0Zm0 2.667H0V4h28V2.667ZM0 5.333h28v1.334H0V5.333ZM28 8H0v1.333h28V8ZM0 10.667h28V12H0v-1.333Zm28 2.666H0v1.334h28v-1.334ZM0 16h28v1.333H0V16Zm28 2.667H0V20h28v-1.333Z",
  fill: "#D02F44"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#46467F",
  d: "M0 0h12v9.333H0z"
}), /*#__PURE__*/react.createElement("g", {
  filter: "url(#US_svg__b)"
}, /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.667 2a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0Zm2.666 0A.667.667 0 1 1 4 2a.667.667 0 0 1 1.333 0Zm2 .667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334ZM10.667 2a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0ZM3.333 4a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Zm3.334-.667a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0Zm2 .667a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Zm2 .667a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0Zm-3.334.666a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Zm-2-.666a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0ZM2 5.333A.667.667 0 1 0 2 4a.667.667 0 0 0 0 1.333ZM4 6a.667.667 0 1 1-1.333 0A.667.667 0 0 1 4 6Zm2 .667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334ZM9.333 6A.667.667 0 1 1 8 6a.667.667 0 0 1 1.333 0ZM10 8a.667.667 0 1 0 0-1.333A.667.667 0 0 0 10 8Zm-2-.667a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0ZM4.667 8a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Zm-2-.667a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0Z",
  fill: "url(#US_svg__c)"
})))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
  id: "US_svg__c",
  x1: 1.333,
  y1: 1.333,
  x2: 1.333,
  y2: 8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/react.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/react.createElement("stop", {
  offset: 1,
  stopColor: "#F0F0F0"
})), /*#__PURE__*/react.createElement("filter", {
  id: "US_svg__b",
  x: 1.333,
  y: 1.333,
  width: 9.333,
  height: 7.667,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/react.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/react.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/react.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/react.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
}), /*#__PURE__*/react.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_301_24"
}), /*#__PURE__*/react.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_301_24",
  result: "shape"
})))));

/* harmony default export */ var US = (SvgUs);
;// CONCATENATED MODULE: ./public/icons/flags/NL.svg
var NL_rect, NL_rect2, NL_g;

function NL_extends() { NL_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return NL_extends.apply(this, arguments); }



const SvgNl = props => /*#__PURE__*/react.createElement("svg", NL_extends({
  viewBox: "0 0 28 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), NL_rect || (NL_rect = /*#__PURE__*/react.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 27.5,
  height: 19.5,
  rx: 1.75,
  fill: "#fff",
  stroke: "#F5F5F5",
  strokeWidth: 0.5
})), /*#__PURE__*/react.createElement("mask", {
  id: "NL_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 28,
  height: 20
}, NL_rect2 || (NL_rect2 = /*#__PURE__*/react.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 27.5,
  height: 19.5,
  rx: 1.75,
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}))), NL_g || (NL_g = /*#__PURE__*/react.createElement("g", {
  mask: "url(#NL_svg__a)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/react.createElement("path", {
  d: "M0 6.667h28V0H0v6.667Z",
  fill: "#CA2B39"
}), /*#__PURE__*/react.createElement("path", {
  d: "M0 20h28v-6.667H0V20Z",
  fill: "#2C56A2"
}))));

/* harmony default export */ var NL = (SvgNl);
// EXTERNAL MODULE: ./components/general/Header/components/Bar/components/Languages/styles.module.scss
var Languages_styles_module = __webpack_require__(40255);
var Languages_styles_module_default = /*#__PURE__*/__webpack_require__.n(Languages_styles_module);
;// CONCATENATED MODULE: ./components/general/Header/components/Bar/components/Languages/index.js











var Languages = function() {
    var languages = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ES, {}),
            short: "es"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FR, {}),
            short: "fr"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(US, {}),
            short: "en"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(NL, {}),
            short: "nl"
        }
    ];
    var isMobile = (0,ResponsiveContext/* useResponsive */.F)().isMobile;
    var ref = (0,react.useState)(/*#__PURE__*/ (0,jsx_runtime.jsx)(US, {})), currentLanguage = ref[0], setCurrentLanguage = ref[1];
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname, asPath = router.asPath, query = router.query;
    (0,react.useEffect)(function() {
        var matchingLanguage = languages.find(function(lang) {
            return lang.short === router.locale;
        });
        if (matchingLanguage) {
            setCurrentLanguage(matchingLanguage.icon);
        // router.reload()
        }
    }, [
        router.locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
        variant: [
            "center",
            "p-md"
        ],
        arrow: !isMobile,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (Languages_styles_module_default()).language,
            children: currentLanguage
        }),
        "aria-label": "Current Language",
        buttonVariant: [
            "align-middle"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Languages_styles_module_default()).languages,
            children: languages.map(function(language, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                    "aria-label": "Change language to ".concat(language.short),
                    arrow: false,
                    onClick: function() {
                        router.push({
                            pathname: pathname,
                            query: query
                        }, asPath, {
                            locale: language.short
                        });
                        setTimeout(function() {
                            return router.reload();
                        }, 1000);
                    },
                    variant: [
                        "label",
                        index !== 0 && "m-l-xs"
                    ],
                    children: language.icon
                }, "language-".concat(language.short));
            })
        })
    });
};
/* harmony default export */ var components_Languages = (Languages);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
;// CONCATENATED MODULE: ./components/general/Header/components/Bar/index.js






// import Measure from './components/Measure'








var Bar = function(param) {
    var translations = param.translations;
    var ref = (0,ResponsiveContext/* useResponsive */.F)(), isSmallMobile = ref.isSmallMobile, isMobile = ref.isMobile;
    var selectedCurrency = (0,currencyProvider/* useCurrencyContext */.VT)().selectedCurrency;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), closeClick = ref1[0], setCloseClick = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
        variant: [
            "-xxl"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).bar,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (styles_module_default()).bar__phone,
                    children: [
                        isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_phone, {}) : "".concat(translations.assistance[router.locale], ": "),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            rel: "nofollow",
                            href: "tel: +1 213-805-0840",
                            children: "+1 213-805-0840"
                        })
                    ]
                }),
                !isSmallMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).bar__dot
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Languages, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).bar__dot
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                    handleClose: closeClick,
                    disabled: !router.asPath.includes("real-estate"),
                    title: "".concat(isSmallMobile ? "" : translations === null || translations === void 0 ? void 0 : translations.currency[router.locale], " ").concat(selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.label),
                    translations: translations,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Currency, {
                        translation: translations,
                        setCloseClick: setCloseClick
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).bar__dot
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/favourites",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        "aria-label": "favourites",
                        name: "favourites",
                        className: (0,withModifiers/* withModifiers */.i)("bar__item", [
                            router.asPath === "/favourites" && "active"
                        ], (styles_module_default())),
                        children: [
                            !isMobile && translations.myFavourites[router.locale],
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_favourite/* default */.Z, {
                                alt: "Heart icon",
                                width: 16,
                                height: 16,
                                className: (styles_module_default()).bar__icon
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_Bar = (Bar);

// EXTERNAL MODULE: ./public/icons/icon-search.svg
var icon_search = __webpack_require__(4860);
// EXTERNAL MODULE: ./components/layout/Column/index.js
var Column = __webpack_require__(70539);
// EXTERNAL MODULE: ./components/layout/Columns/index.js
var Columns = __webpack_require__(40050);
// EXTERNAL MODULE: ./components/general/Header/components/Navigation/components/Rentals/styles.module.scss
var Rentals_styles_module = __webpack_require__(83954);
var Rentals_styles_module_default = /*#__PURE__*/__webpack_require__.n(Rentals_styles_module);
;// CONCATENATED MODULE: ./components/general/Header/components/Navigation/components/Rentals/rentals.js
var rentals = {
    main: [
        {
            title: {
                en: "Exclusive Properties",
                fr: "Propri\xe9t\xe9s exclusives",
                es: "Propiedades Exclusivas",
                nl: "Exclusieve eigenschappen"
            },
            link: "/vacation-rentals?homeType=exclusive",
            onBoth: true
        },
        {
            title: {
                en: "New Listings",
                fr: "Nouvelles annonces",
                es: "Nuevos listados",
                nl: "Nieuwe aanbiedingen"
            },
            link: "/vacation-rentals?sorting=listings"
        },
        {
            title: {
                en: "Beachfront",
                fr: "Propri\xe9t\xe9s en bord de mer",
                es: "Propiedades frente al mar",
                nl: "Eigenschappen aan het strand"
            },
            link: "/vacation-rentals?amenities=beachfront",
            onlyVacationRentals: true
        },
        {
            title: {
                en: "villas",
                fr: "villas",
                es: "villas",
                nl: "villa's"
            },
            link: "/vacation-rentals?homeType=villa",
            onBoth: true
        },
        {
            title: {
                en: "Condos",
                fr: "Copropri\xe9t\xe9s",
                es: "Condominios",
                nl: "Appartementen"
            },
            link: "/vacation-rentals?homeType=condominium",
            onBoth: true
        },
        {
            title: {
                en: "Land",
                fr: "Le Terrain",
                es: "El Terreno",
                nl: "Grondbezit"
            },
            link: "/vacation-rentals?homeType=land",
            onBoth: false
        }
    ]
};
/* harmony default export */ var Rentals_rentals = (rentals);

// EXTERNAL MODULE: ./providers/SearchContext.js
var SearchContext = __webpack_require__(65079);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/general/Header/components/Navigation/components/Rentals/index.js









var Rentals = function(param) {
    var setActive = param.setActive, setCloseClick = param.setCloseClick, setChange = param.setChange, locations = param.locations, translations = param.translations, _defaultUrl = param.defaultUrl, defaultUrl = _defaultUrl === void 0 ? "vacation-rentals" : _defaultUrl;
    var router = (0,next_router.useRouter)();
    var ref = (0,SearchContext/* useSearchContext */.AB)(), setSearchActive = ref.setSearchActive, setSearch = ref.setSearch, initialValues = ref.initialValues;
    (0,react.useEffect)(function() {
        var elements = 0;
        Rentals_rentals.main.map(function(item) {
            if (item.link.replace("vacation-rentals", defaultUrl) === router.asPath) {
                elements = elements + 1;
            }
        });
        locations && locations.map(function(column) {
            return column.items.map(function(item) {
                if (item.link.replace("vacation-rentals", defaultUrl) === router.asPath) {
                    elements = elements + 1;
                }
            });
        });
        if (elements === 0) {
            setActive && setActive(false);
        } else {
            setSearchActive(false);
            setActive && setActive(true);
        }
    }, []);
    var executeHide = function() {
        if (setCloseClick) {
            setCloseClick(true);
            setTimeout(function() {
                return setCloseClick(false);
            }, 20);
        }
        if (setChange) {
            setChange(true);
            setTimeout(function() {
                return setChange(false);
            }, 20);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Rentals_styles_module_default()).rentals,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Rentals_styles_module_default()).rentals__column,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: (Rentals_styles_module_default()).rentals__list,
                    children: [
                        defaultUrl !== "vacation-rentals" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (0,withModifiers/* withModifiers */.i)("rentals__listItem", [
                                router.asPath === "/real-estate" && "is-active",
                                "main"
                            ], (Rentals_styles_module_default())),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/real-estate",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (Rentals_styles_module_default()).rentals__link,
                                    children: translations.realEstate[router.locale]
                                })
                            })
                        }),
                        Rentals_rentals.main.map(function(item, index) {
                            var shouldDisplay;
                            if (item.onBoth) {
                                shouldDisplay = true;
                            } else if (item.onlyVacationRentals) {
                                shouldDisplay = defaultUrl === "vacation-rentals";
                            } else {
                                shouldDisplay = defaultUrl !== "vacation-rentals";
                            }
                            return shouldDisplay && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: classnames_default()((0,withModifiers/* withModifiers */.i)("rentals__listItem", [
                                    router.asPath === item.link.replace("vacation-rentals", defaultUrl) && "is-active"
                                ], (Rentals_styles_module_default())), item.disabled && "disabled"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: item.link.includes("condominium") && defaultUrl !== "vacation-rentals" ? item.link.replace("condominium", "condo").replace("vacation-rentals", defaultUrl) : item.link.replace("vacation-rentals", defaultUrl),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        onClick: function() {
                                            return executeHide();
                                        },
                                        className: (Rentals_styles_module_default()).rentals__link,
                                        children: item.title[router.locale]
                                    })
                                })
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (0,withModifiers/* withModifiers */.i)("rentals__listItem", [
                                router.asPath === "/".concat(defaultUrl) && "is-active",
                                "last"
                            ], (Rentals_styles_module_default())),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/".concat(defaultUrl),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    onClick: function() {
                                        setSearch(initialValues);
                                        executeHide();
                                    },
                                    className: (Rentals_styles_module_default()).rentals__link,
                                    children: defaultUrl === "vacation-rentals" ? translations.allRentals[router.locale] : translations.allListings[router.locale]
                                })
                            })
                        })
                    ]
                })
            }),
            locations && locations.map(function(column, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Rentals_styles_module_default()).rentals__column,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Rentals_styles_module_default()).rentals__title,
                            children: column.title[router.locale]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: column.items.length > 6 ? (Rentals_styles_module_default()).rentals__grid : (Rentals_styles_module_default()).rentals__flex,
                            children: column.items.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: item.link,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        onClick: function() {
                                            return executeHide();
                                        },
                                        className: (0,withModifiers/* withModifiers */.i)("rentals__link", [
                                            router.asPath === item.link && "is-active"
                                        ], (Rentals_styles_module_default())),
                                        children: item.title
                                    })
                                }, "link-".concat(index));
                            })
                        })
                    ]
                }, "column-".concat(index));
            })
        ]
    });
};
/* harmony default export */ var components_Rentals = (Rentals);

// EXTERNAL MODULE: ./components/elements/DateSearch/index.js + 10 modules
var DateSearch = __webpack_require__(85137);
// EXTERNAL MODULE: ./components/general/Header/components/Navigation/components/Menu/styles.module.scss
var Menu_styles_module = __webpack_require__(54201);
var Menu_styles_module_default = /*#__PURE__*/__webpack_require__.n(Menu_styles_module);
// EXTERNAL MODULE: ./components/elements/Accordion/index.js
var Accordion = __webpack_require__(42192);
// EXTERNAL MODULE: ./components/elements/Hamburger/styles.module.scss
var Hamburger_styles_module = __webpack_require__(860);
var Hamburger_styles_module_default = /*#__PURE__*/__webpack_require__.n(Hamburger_styles_module);
;// CONCATENATED MODULE: ./components/elements/Hamburger/index.js








var Hamburger = function(param) {
    var trigger = param.trigger, children = param.children, setMenuOpen = param.setMenuOpen, changeState = param.changeState, translations = param.translations;
    var isSmallMobile = (0,ResponsiveContext/* useResponsive */.F)().isSmallMobile;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), mounted = ref1[0], setMounted = ref1[1];
    var body =  true && document.querySelector("body");
    var wrapperRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    // Handle body class for mobile
    (0,react.useEffect)(function() {
        if (!isSmallMobile || !body) return;
        if (open) {
            body.classList.add("modal-open");
        } else {
            body.classList.remove("modal-open");
        }
        return function() {
            body.classList.remove("modal-open");
        };
    }, [
        open,
        isSmallMobile,
        body
    ]);
    // Handle opening and closing of the menu
    var handleOpen = function() {
        // For opening
        if (!open) {
            // First mount the content without the open class
            setMounted(true);
            // Use requestAnimationFrame to ensure DOM update before setting open state
            // This creates a sequence that allows the entry animation to work
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    setOpen(true);
                    setMenuOpen && setMenuOpen(true);
                });
            });
        } else {
            setOpen(false);
            setMenuOpen && setMenuOpen(false);
            // Wait for transition to complete before unmounting
            var transitionDuration = 300 // Match with your CSS transition duration
            ;
            setTimeout(function() {
                setMounted(false);
            }, transitionDuration);
        }
    };
    // Click outside handler
    (0,react.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target) && open) {
                handleOpen();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        open
    ]);
    // Handle route changes
    (0,react.useEffect)(function() {
        return function() {
            body && body.classList.remove("modal-open");
        };
    }, []);
    (0,react.useEffect)(function() {
        if (open) {
            setOpen(false);
            setMenuOpen && setMenuOpen(false);
            var transitionDuration = 300 // Match this with your CSS transition duration
            ;
            setTimeout(function() {
                setMounted(false);
            }, transitionDuration);
        }
    }, [
        router.asPath
    ]);
    // Handle external state changes
    (0,react.useEffect)(function() {
        if (changeState === true && !open) {
            setMounted(true) // Ensure content is mounted before animation
            ;
            // Use requestAnimationFrame for smoother animation
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    setOpen(true);
                    setMenuOpen && setMenuOpen(true);
                });
            });
        }
    }, [
        changeState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: wrapperRef,
        className: classnames_default()((Hamburger_styles_module_default()).menu, open && (Hamburger_styles_module_default()).isOpen),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: handleOpen,
                className: (Hamburger_styles_module_default()).menu__trigger,
                children: trigger
            }),
            (mounted || open) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Hamburger_styles_module_default()).menu__content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Hamburger_styles_module_default()).menu__overflow,
                        children: children
                    }),
                    isSmallMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Hamburger_styles_module_default()).menu__footer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                disabled: router.asPath === "/contact",
                                href: "/contact",
                                variant: [
                                    "full-width"
                                ],
                                children: translations.getInTouch[router.locale]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                prepend: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_phone, {}),
                                variant: [
                                    "full-width"
                                ],
                                arrow: false,
                                rel: "nofollow",
                                href: "tel: +1 213-805-0840",
                                children: translations.callUs[router.locale]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var elements_Hamburger = (Hamburger);

;// CONCATENATED MODULE: ./components/general/Header/components/Navigation/components/Menu/index.js











var Menu = function(param) {
    var locations = param.locations, realEstateLocations = param.realEstateLocations, translations = param.translations;
    var isSmallMobile = (0,ResponsiveContext/* useResponsive */.F)().isSmallMobile;
    var ref = (0,react.useState)(false), menuOpen = ref[0], setMenuOpen = ref[1];
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), change = ref1[0], setChange = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(elements_Hamburger, {
        translations: translations,
        setMenuOpen: setMenuOpen,
        changeState: change,
        trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Menu_styles_module_default()).menu__hamburger,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    ]
                }),
                !isSmallMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Menu_styles_module_default()).menu__label,
                    children: menuOpen ? translations.close[router.locale] : translations.menu[router.locale]
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                title: translations.rentals[router.locale],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Rentals, {
                    translations: translations,
                    locations: locations,
                    setChange: setChange
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                title: translations.realEstate[router.locale],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Rentals, {
                    translations: translations,
                    locations: realEstateLocations,
                    setChange: setChange,
                    defaultUrl: "real-estate/search"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,withModifiers/* withModifiers */.i)("menu__item", [
                    router.pathname === "/guest-experience" && "current"
                ], (Menu_styles_module_default())),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/guest-experience",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: translations.guestExperience[router.locale]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,withModifiers/* withModifiers */.i)("menu__item", [
                    router.pathname === "/stories" && "current"
                ], (Menu_styles_module_default())),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/stories",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: translations.stories[router.locale]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                href: "/real-estate/search",
                className: (Menu_styles_module_default()).menu__button,
                children: translations.buyOrSellWithUs[router.locale]
            })
        ]
    });
};
/* harmony default export */ var components_Menu = (Menu);

// EXTERNAL MODULE: ./components/general/Header/components/Navigation/styles.module.scss
var Navigation_styles_module = __webpack_require__(51590);
var Navigation_styles_module_default = /*#__PURE__*/__webpack_require__.n(Navigation_styles_module);
;// CONCATENATED MODULE: ./public/logo.svg
var logo_path;

function logo_extends() { logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logo_extends.apply(this, arguments); }



const SvgLogo = props => /*#__PURE__*/react.createElement("svg", logo_extends({
  viewBox: "0 0 254 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), logo_path || (logo_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M187.464 21.72v-.418l1.647-.613V13.3c0-1.906-.763-3.047-2.584-3.047a6.469 6.469 0 0 0-3.055.734v9.703l1.646.613v.417h-6.634v-.412l1.848-.623V2.99l-2.028-1.326v-.285L183.355 0l.117.09v10.257l.116.058c1.737-1.637 3.32-2.371 4.909-2.371 2.642 0 3.759 1.986 3.759 4.072v8.589l1.843.607v.417h-6.635Zm-43.451.432c3.171 0 6.433-2.287 6.433-6.153 0-2.16-1.117-3.655-3.495-4.801-.609-.297-1.256-.555-1.888-.808a33.554 33.554 0 0 1-1.432-.597c-2.086-.909-2.673-1.965-2.673-3.344 0-1.727 1.117-2.841 2.79-2.841 1.911 0 3.643 1.574 5.258 4.8l.588-.089-.498-5.741h-.498l-1.144.993c-.969-.56-1.969-.967-3.436-.967-2.965 0-5.994 2.113-5.994 5.599 0 2.14 1.086 3.75 3.145 4.775.615.295 1.308.565 1.984.827h.001c.326.127.647.252.954.377 2.759 1.14 3.436 1.991 3.436 3.75 0 1.849-1.233 3.222-3.351 3.222s-4.199-1.347-6.052-5.567l-.615.058.35 6.507h.529l1.144-1.024a9.911 9.911 0 0 0 4.464 1.024Zm100.531-16.12h-3.124l-2.754 6.65h.646l5.232-6.65Zm-91.773 9.058c0-3.607 2.526-7.062 7.053-7.062 4.464 0 6.609 3.164 6.609 7.03 0 3.64-2.468 7.12-6.995 7.12-4.464 0-6.667-3.19-6.667-7.088Zm3.469.058c0 3.957 1.35 6.212 3.436 6.212v-.005c2.145 0 3.32-2.34 3.32-6.296 0-3.957-1.26-6.212-3.436-6.212-2.06 0-3.32 2.345-3.32 6.301Zm21.173 5.594-.026-.412-.202.01c-.495.023-1.003.048-1.413.048-.969 0-1.647-.116-2.144-.47-.588-.412-.763-1.114-.763-2.287v-7.59h4.469V8.514h-4.469V4.706h-.434l-2.145 2.784-2.7 2.139v.412h2.176v8.762c0 2.113.731 3.254 3.055 3.254 1.589 0 3.469-.623 4.612-1.32l-.016.005Zm30.028-1.083-.174-.354c-1.764.645-2.971.94-4.438.94-3.32 0-4.379-2.435-4.379-6.153h9.134c.032-3.46-1.848-6.064-5.729-6.064-3.585 0-6.756 3.138-6.756 7.326 0 4.189 2.647 6.83 6.666 6.83 1.88 0 3.876-.967 5.671-2.52l.005-.005Zm-5.787-10.812c1.731 0 2.526 1.495 2.642 4.247l-5.814.264c.148-2.726 1.467-4.511 3.172-4.511Zm16.303-.818c2.79 0 5.315 2.55 5.316 6.736-.001 4.193-3.172 7.414-7.873 7.414-1.525 0-3.553-.349-4.962-.76V2.994l-2.054-1.326v-.29L213.467 0l.116.09v9.814l.117.058c1.027-1.025 2.436-1.933 4.257-1.933Zm-4.379 11.81a4.437 4.437 0 0 0 3.204 1.347l-.006-.006c1.732 0 3.172-1.552 3.172-5.683 0-3.629-1.557-5.42-4.051-5.42-.794 0-1.583.16-2.319.471v9.29Zm22.885-9.983-5.138 12.77.002.002c-1.466 3.602-2.848 5.186-4.67 5.186-1.557 0-2.293-.94-2.293-1.848 0-.909.832-1.67 1.764-1.67.995 0 1.583.529 2.287 1.406a11.437 11.437 0 0 0 1.615-2.483l.498-1.114-5.2-12.513-1.795-.703v-.38h7.17v.38l-1.88.703 3.172 8.588h.148l2.88-8.382-1.705-.909v-.38h5.052v.38l-1.907.967Zm11.305 6.494-.137-.056-.005-.005c-1.854-.792-3.818-1.669-3.818-4.104 0-2.313 2.054-4.157 5.051-4.157 1.144 0 2.759.238 3.553.529l.09 3.486-.556.148c-1.44-2.372-2.382-3.28-3.733-3.28-1.233 0-1.991.829-1.991 1.875 0 1.498 1.531 2.116 3.17 2.777l.092.038c1.853.76 3.85 1.637 3.85 4.135 0 2.726-2.41 4.453-5.258 4.448h-.011a11.652 11.652 0 0 1-4.347-.792l-.027-3.867.588-.058c1.589 2.784 2.791 3.835 4.347 3.835 1.382 0 2.235-.877 2.235-2.224 0-1.485-1.468-2.075-3.093-2.728Zm-5.882 17.306h2.208v6.212h.677v-6.212h2.208v-.607h-5.093v.608Zm-84.614 2.906h-2.558v2.704h3.622v.602h-4.278v-6.824h4.082v.607h-3.426v2.319h2.558v.592Zm7.497-1.67c0-1.199-.847-1.843-2.372-1.843h-2.292v6.819h.64V36.81h1.7l1.673 3.058h.736l-1.721-3.132c.996-.185 1.636-.74 1.636-1.844Zm-2.419 1.337h-1.599v-2.583h1.588c1.149 0 1.774.333 1.774 1.273 0 .993-.636 1.31-1.763 1.31Zm-12.634-2.572h-2.208v-.608h5.072v.608h-2.208v6.211h-.656v-6.212Zm89.205-.608h-.662v6.819h4.019v-.602h-3.357v-6.217Zm-101.019 0h.657v6.819h-.657v-6.82Zm85.959 1.843c0-1.199-.847-1.843-2.372-1.843h-2.298v6.819h.651V36.81h1.7l1.673 3.058h.736l-1.726-3.132c.996-.185 1.636-.74 1.636-1.844Zm-2.419 1.337h-1.6v-2.583h1.589c1.149 0 1.774.333 1.774 1.273 0 .993-.636 1.31-1.763 1.31Zm-76.047 2.45h.016v-5.63h.619v6.819h-.582l-3.892-5.794h-.016v5.794h-.619v-6.819h.704l3.77 5.63Zm104.962-2.377-1.922-3.253h-.709l2.292 3.813v3.006h.657v-3.006l2.298-3.813h-.704l-1.912 3.254ZM201.49 38.68h.022v-5.63h.619v6.819h-.582l-3.892-5.794h-.016v5.794h-.62v-6.82h.699l3.77 5.631Zm25.109-2.117h2.557v-.592h-2.557V33.65h3.426v-.607h-4.083v6.824h4.284v-.602h-3.627v-2.704Zm-22.689 3.306 2.42-6.846h.715l2.409 6.846h-.683l-.731-2.102h-2.769l-.731 2.102h-.63Zm2.738-6.064-1.176 3.386v.005h2.367l-1.175-3.39h-.016Zm5.284-.755h-.667v6.819h4.013v-.602h-3.346v-6.217Zm-22.774 3.412c0-2.14 1.213-3.539 2.886-3.539s2.88 1.4 2.88 3.54c0 2.138-1.207 3.538-2.88 3.538-1.673 0-2.886-1.4-2.886-3.539Zm.662 0c0 1.849.932 2.947 2.224 2.947h.005c1.292 0 2.224-1.093 2.224-2.947s-.927-2.942-2.224-2.942c-1.297 0-2.229 1.093-2.229 2.942Zm-9.923-2.805h2.203v6.212h.667v-6.212h2.208v-.607h-5.078v.607Zm6.64-.607h.662v6.819h-.662v-6.819Zm46.945-.021-2.416 6.835h-.003v.01l.003-.01h.637l.726-2.092h2.769l.731 2.102h.683l-2.42-6.845h-.71Zm-.847 4.157 1.165-3.386h.016l1.176 3.391h-2.357v-.005Zm-58.71 2.683 2.42-6.846h.704l2.42 6.846h-.683l-.731-2.102h-2.769l-.731 2.102h-.63Zm2.737-6.064-1.175 3.386v.005h2.367l-1.176-3.39h-.016Zm-5.131 4.876h-.016l-3.77-5.631h-.693v6.819h.614v-5.794h.016l3.891 5.794h.583v-6.819h-.625v5.63ZM123.167.016h.609V39.98h-.609V.016ZM7.482 18.117c-3.903-1.247-5.126-1.944-5.126-4.014 0-1.696 1.499-3.016 3.977-3.016 2.324 0 3.95.945 4.877 3.343l1.498-.697c-.874-2.467-2.875-4.241-6.354-4.241s-5.75 2.086-5.75 4.732c0 3.043 2.028 4.115 5.999 5.361 3.923 1.247 4.85 2.219 4.85 4.141 0 2.07-1.8 3.344-4.575 3.344-2.6 0-4.474-1.32-5.3-3.893L0 23.753c.874 2.995 3.325 4.89 6.804 4.89 3.701 0 6.428-1.97 6.428-5.038 0-3.069-1.9-4.268-5.75-5.488Zm11.93-1.495v8.256h-.005c0 1.394.45 2.144 2.075 2.144.503 0 1.001-.047 1.377-.174v1.474c-.397.073-1.101.147-1.7.147-2.525 0-3.473-.972-3.473-3.243v-8.604h-2.298v-1.474h2.298v-4.716h1.726v4.716h3.426v1.474h-3.426Zm8.927 9.328h-2.15v2.345h2.15V25.95Zm18.808.048h.047l6.153-16.163h2.351V28.29h-1.773V12.825h-.048c-.249.824-.7 2.044-1.15 3.243L47.926 28.29H46.3l-4.803-12.222-.05-.132c-.422-1.12-.711-1.887-1.099-3.159h-.047v15.518h-1.653V9.835h2.298l6.2 16.163Zm22.726-6.909c0-2.62-1.276-4.189-4.225-4.189-2.6 0-4.427.999-6 2.446l.927 1.072c1.377-1.199 2.849-2.07 4.924-2.07 1.727 0 2.674.871 2.674 2.693v.671c-6.703 1.025-8.927 2.921-8.927 5.515 0 2.044 1.377 3.29 3.728 3.29 1.975 0 3.675-.723 5.2-2.097 0 .75.126 1.32.301 1.87h1.774c-.275-.676-.376-1.648-.376-3.243v-5.958Zm-1.7 5.937c-1.35 1.3-2.975 2.07-4.823 2.07-1.478 0-2.399-.723-2.399-2.097 0-1.721 1.578-3.116 7.228-4.067v4.094h-.006Zm7.28-7.284h.048c1.027-1.622 2.626-2.842 5.226-2.842h.302l-.175 1.595s-.476-.026-.524-.026c-2.15 0-3.85 1.199-4.876 3.27v8.556h-1.727V15.148h1.727v2.594Zm10.776 7.136v-8.256h3.426v-1.474H86.23v-4.716h-1.726v4.716h-2.298v1.474h2.298v8.604c0 2.271.948 3.243 3.474 3.243.598 0 1.302-.074 1.7-.148v-1.473c-.377.127-.874.174-1.377.174-1.626 0-2.076-.75-2.076-2.144h.005Zm6.65-9.73h1.726v13.147H92.88V15.148Zm1.774-4.89h-1.827v1.848h1.827v-1.849Zm5.804 6.96c1.276-1.246 2.949-2.318 5.024-2.318l.006.005c2.6 0 3.923 1.448 3.923 3.893V28.3h-1.726v-9.18c0-1.848-.826-2.746-2.626-2.746-1.7 0-3.124.871-4.601 2.292v9.63H98.73V15.147h1.727v2.07Z",
  fill: "#fff"
})));

/* harmony default export */ var logo = (SvgLogo);
// EXTERNAL MODULE: ./components/configs/axios.js
var axios = __webpack_require__(92375);
;// CONCATENATED MODULE: ./components/general/Header/components/Navigation/index.js




















var Navigation = function(param) {
    var translations = param.translations;
    var ref = (0,ResponsiveContext/* useResponsive */.F)(), isTablet = ref.isTablet, isMobile = ref.isMobile, isSmallMobile = ref.isSmallMobile;
    var ref1 = (0,react.useState)(false), active = ref1[0], setActive = ref1[1];
    var ref2 = (0,react.useState)(false), realEstateActive = ref2[0], setRealEstateActive = ref2[1];
    var searchActive = (0,SearchContext/* useSearchContext */.AB)().searchActive;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(false), closeClick = ref3[0], setCloseClick = ref3[1];
    var ref4 = (0,react.useState)(false), closeEstateClick = ref4[0], setCloseEstateClick = ref4[1];
    var ref5 = (0,react.useState)(false), loaded = ref5[0], setLoaded = ref5[1];
    var ref6 = (0,react.useState)(false), locations = ref6[0], setLocations = ref6[1];
    var ref7 = (0,react.useState)(false), realEstateLocations = ref7[0], setRealEstateLocations = ref7[1];
    (0,react.useEffect)(function() {
        axios/* default.get */.Z.get("listings/neighbourhood").then(function(response) {
            var locations = response.data.map(function(location) {
                return {
                    title: location.title,
                    items: location.options.map(function(option) {
                        return {
                            title: option.label,
                            link: option.link
                        };
                    })
                };
            });
            setLocations(locations);
        }).catch(function(error) {
            console.error(error);
        });
    }, [
        router.locale
    ]);
    (0,react.useEffect)(function() {
        axios/* default.get */.Z.get("real-estate/neighbourhood").then(function(response) {
            var locations = response.data.map(function(location) {
                return {
                    title: location.title,
                    items: location.options.map(function(option) {
                        return {
                            title: option.label,
                            link: "/real-estate/search?location=".concat(option.value)
                        };
                    })
                };
            });
            setRealEstateLocations(locations);
        }).catch(function(error) {
            console.error(error);
        });
    }, [
        router.locale
    ]);
    (0,react.useEffect)(function() {
        return setLoaded(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Navigation_styles_module_default()).navigation,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
            variant: [
                "-xxl"
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Columns/* default */.Z, {
                variant: [
                    "-distribute-between",
                    "no-gutter"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                        className: (Navigation_styles_module_default()).column,
                        variant: [
                            "no-padding",
                            "-align-center"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                title: "St Martin Sotheby's logo",
                                className: (0,withModifiers/* withModifiers */.i)("logo", [
                                    router.pathname === "/" && "current"
                                ], (Navigation_styles_module_default())),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {
                                    width: isSmallMobile ? 170 : isMobile ? 202 : 254
                                })
                            })
                        })
                    }),
                    !isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                        className: (Navigation_styles_module_default()).columnRight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Navigation_styles_module_default()).navigation__items,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                    handleClose: closeClick,
                                    active: active,
                                    custom: true,
                                    title: translations.rentals[router.locale],
                                    children: loaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Rentals, {
                                        translations: translations,
                                        setCloseClick: setCloseClick,
                                        setActive: setActive,
                                        locations: locations
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                    handleClose: closeEstateClick,
                                    active: realEstateActive,
                                    custom: true,
                                    href: "/real-estate",
                                    title: translations.realEstate[router.locale],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Rentals, {
                                        translations: translations,
                                        setCloseClick: setCloseEstateClick,
                                        setActive: setRealEstateActive,
                                        locations: realEstateLocations,
                                        defaultUrl: "real-estate/search"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/guest-experience",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (0,withModifiers/* withModifiers */.i)("navigation__item", [
                                            (router.asPath === "/guest-experience" || !router.asPath === "/guest-experience" && realEstateActive) && "active"
                                        ], (Navigation_styles_module_default())),
                                        href: "/real-estate",
                                        title: "Real Estate",
                                        children: translations.guestExperience[router.locale]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/stories",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (0,withModifiers/* withModifiers */.i)("navigation__item", [
                                            router.asPath === "/stories" && "active"
                                        ], (Navigation_styles_module_default())),
                                        children: translations.stories[router.locale]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                    custom: true,
                                    active: searchActive,
                                    prepend: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_search/* default */.Z, {
                                        width: isSmallMobile ? 18 : isMobile ? 18 : 24
                                    }),
                                    arrow: false,
                                    title: translations === null || translations === void 0 ? void 0 : translations.search[router.locale],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSearch/* default */.Z, {
                                        form: [
                                            "dates",
                                            "bedrooms",
                                            "listings"
                                        ],
                                        translations: translations,
                                        custom: true,
                                        button: true
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                        variant: [
                            "no-padding",
                            "justify-right",
                            "align-middle",
                            isTablet && "-static"
                        ],
                        className: (Navigation_styles_module_default()).column,
                        children: [
                            isTablet && !isSmallMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                custom: true,
                                active: searchActive,
                                prepend: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_search/* default */.Z, {
                                    width: isSmallMobile ? 18 : isMobile ? 18 : 24
                                }),
                                arrow: false,
                                title: translations === null || translations === void 0 ? void 0 : translations.search[router.locale],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSearch/* default */.Z, {
                                    translations: translations,
                                    form: [
                                        "dates",
                                        "bedrooms",
                                        "listings"
                                    ],
                                    button: true
                                })
                            }),
                            isSmallMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_Hamburger, {
                                translations: translations,
                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_search/* default */.Z, {
                                    className: (Navigation_styles_module_default()).navigation__search,
                                    width: 18
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateSearch/* default */.Z, {
                                    translations: translations,
                                    form: [
                                        "dates",
                                        "bedrooms",
                                        "listings"
                                    ],
                                    button: true
                                })
                            }),
                            !isSmallMobile && isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Navigation_styles_module_default()).navigation__dot
                            }),
                            !isSmallMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                className: (Navigation_styles_module_default()).navigation__button,
                                disabled: router.asPath === "/contact",
                                href: "/contact",
                                arrow: false,
                                children: translations === null || translations === void 0 ? void 0 : translations.getInTouch[router.locale]
                            }),
                            isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Navigation_styles_module_default()).navigation__dot
                            }),
                            isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Menu, {
                                locations: locations,
                                realEstateLocations: realEstateLocations,
                                setCloseClick: setCloseClick,
                                translations: translations
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_Navigation = (Navigation);

// EXTERNAL MODULE: ./components/general/Header/styles.module.scss
var Header_styles_module = __webpack_require__(90444);
var Header_styles_module_default = /*#__PURE__*/__webpack_require__.n(Header_styles_module);
;// CONCATENATED MODULE: ./components/general/Header/index.js





var Header = function(param) {
    var translations = param.translations;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (Header_styles_module_default()).header,
        children: [
            translations && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Bar, {
                translations: translations
            }),
            translations && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Navigation, {
                translations: translations
            })
        ]
    });
};
/* harmony default export */ var general_Header = (/*#__PURE__*/react.memo(Header));

// EXTERNAL MODULE: ./components/templates/Page/styles.module.scss
var Page_styles_module = __webpack_require__(37501);
var Page_styles_module_default = /*#__PURE__*/__webpack_require__.n(Page_styles_module);
;// CONCATENATED MODULE: ./components/helpers/text_truncate.js
var text_truncate = function(str, length, ending) {
    if (length == null) {
        length = 100;
    }
    if (ending == null) {
        ending = "...";
    }
    if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
    } else {
        return str;
    }
};

;// CONCATENATED MODULE: ./components/templates/Page/index.js
/* eslint-disable no-undef */ 


var CTA = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7437)]).then(__webpack_require__.bind(__webpack_require__, 27437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27437)
            ];
        }
    }
});

var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8255)]).then(__webpack_require__.bind(__webpack_require__, 8255));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8255)
            ];
        }
    }
});


var Modal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3508).then(__webpack_require__.bind(__webpack_require__, 83508));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83508)
            ];
        }
    }
});



var Page = function(param) {
    var children = param.children, meta = param.meta, _footer = param.footer, footer = _footer === void 0 ? true : _footer, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, headerTranslation = param.headerTranslation, footerTranslation = param.footerTranslation, ctaTranslation = param.ctaTranslation;
    var router = (0,next_router.useRouter)();
    var canonicalUrl = ("".concat("https://sxmsir.com") + router.asPath).split("?")[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: (0,withModifiers/* withModifiers */.i)("main", variant, (Page_styles_module_default())),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    meta.title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: meta.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:title",
                                content: meta.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: meta.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }),
                    meta.description && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: text_truncate(meta.description, 150, "...")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: text_truncate(meta.description, 150, "...")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:description",
                                content: text_truncate(meta.description, 150, "...")
                            })
                        ]
                    }),
                    meta.image ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: meta.image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: meta.image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:secure_url",
                                content: meta.image
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "image",
                                property: "og:image",
                                content: "/manifest/android-chrome-512x512.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: "/manifest/android-chrome-512x512.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:secure_url",
                                content: "/manifest/android-chrome-512x512.png"
                            })
                        ]
                    }),
                    meta.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image:alt",
                        content: meta.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container["default"], {
                variant: [
                    "-xxl",
                    "-p0"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(general_Header, {
                        translations: headerTranslation
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Page_styles_module_default()).main__content,
                        children: [
                            children,
                            variant.includes("one-section") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Page_styles_module_default()).main__circle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Page_styles_module_default()).main__circle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Page_styles_module_default()).main__circle
                                    })
                                ]
                            })
                        ]
                    }),
                    footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(CTA, {
                        translations: ctaTranslation
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        translations: headerTranslation
                    }),
                    footerTranslation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        translations: footerTranslation
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var templates_Page = (Page);


/***/ }),

/***/ 77627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radio":"styles_radio__ESXm9","field__content":"styles_field__content__hdjB5","radio__content":"styles_radio__content__F1xEy"};

/***/ }),

/***/ 65097:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__qxqml","accordion__trigger":"styles_accordion__trigger__xvGq5","accordion__caret":"styles_accordion__caret__62beK","accordion__content":"styles_accordion__content__LJUaN","accordion--is-open":"styles_accordion--is-open__ljgsL","accordion--large":"styles_accordion--large__HnaY_","accordion__line":"styles_accordion__line__lulrh","accordion__title":"styles_accordion__title__BLT6Y","accordion__plus":"styles_accordion__plus__mJbZL"};

/***/ }),

/***/ 80111:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__f_N_u","button--round":"styles_button--round__cK9f8","button__arrow":"styles_button__arrow___3cTZ","button__label":"styles_button__label__Txjsr","button__prepend":"styles_button__prepend__Er0rd","button__append":"styles_button__append__VMAnR","button--full-width":"styles_button--full-width__QYR3_","button--close":"styles_button--close__2Gikx","button--gray":"styles_button--gray__kp5n8","button--gold":"styles_button--gold__qxYAC","button--blue":"styles_button--blue__zO9Ks","button--label":"styles_button--label__zGt6D","button--secondary":"styles_button--secondary__d_sTo","button--thin":"styles_button--thin__3H4JT","button--primary-blue":"styles_button--primary-blue__8qvKa","button--border-sm":"styles_button--border-sm__QTEJy","button--color-accent":"styles_button--color-accent__O0do1","button--primary":"styles_button--primary__JLu58","button--color-primary":"styles_button--color-primary__GI07o","button--arrow-accent":"styles_button--arrow-accent__vfVlL","button--font-primary":"styles_button--font-primary__3FuDF","button--offset-left":"styles_button--offset-left___Xzc7","button--offset-right":"styles_button--offset-right__NhIot","button--m-l-xs":"styles_button--m-l-xs__zxSPK","button--m-b-xs":"styles_button--m-b-xs__OTSQP","button--m-t-3xl":"styles_button--m-t-3xl__bJY7d","button--m-t-2xl":"styles_button--m-t-2xl__Ax2u7","button--m-t-xl":"styles_button--m-t-xl__pxGcO","button--xl":"styles_button--xl__O6KLb","button--xs":"styles_button--xs__tILcA","button--mt-lg":"styles_button--mt-lg__rjFVt","button--align-middle":"styles_button--align-middle__e0QeW"};

/***/ }),

/***/ 67912:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"disabled":"styles_disabled__qKnkN","disabled--full-width":"styles_disabled--full-width__zlS2C"};

/***/ }),

/***/ 44234:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"field":"styles_field__xZ3EA","field__radios":"styles_field__radios__Ig17Z","isShown":"styles_isShown__hSQfv","custom":"styles_custom__tDV_N","field__content":"styles_field__content__6rpZ0","field__radio":"styles_field__radio__ydNCX"};

/***/ }),

/***/ 57477:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filters":"styles_filters__dH_Oo","filters__label":"styles_filters__label__XEaKL","filters__amenities":"styles_filters__amenities__K6D8r","field":"styles_field__USouU","field__radios":"styles_field__radios__gCLlB","isShown":"styles_isShown__knYSg","custom":"styles_custom__O6f3D","field__content":"styles_field__content__TY4KW","field__radio":"styles_field__radio__uuQxg"};

/***/ }),

/***/ 37103:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"field":"styles_field__wLHRo","isShown":"styles_isShown__MYUTS","custom":"styles_custom__3mwBu","location":"styles_location__arWM5","location__column":"styles_location__column___mq5L","location__title":"styles_location__title__WW605"};

/***/ }),

/***/ 24199:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"field":"styles_field__UP7l8","field__radios":"styles_field__radios__KOJyA","isShown":"styles_isShown__afRP_","custom":"styles_custom__Za0BT","field__content":"styles_field__content__4sguf","field__radio":"styles_field__radio__1dC2_"};

/***/ }),

/***/ 22648:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__NgN8i","wrapper":"styles_wrapper__GH6vH","search":"styles_search__yD59k","submit":"styles_submit__QKYB9","submit--disabled":"styles_submit--disabled__rpW7A","button":"styles_button__YirlT"};

/***/ }),

/***/ 63714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"styles_dropdown__EFx2Y","dropdown--disabled":"styles_dropdown--disabled__xSYt2","dropdown--is-open":"styles_dropdown--is-open__uMCy6","dropdown__wrapper":"styles_dropdown__wrapper__0AYqu","dropdown__content":"styles_dropdown__content__0x6kT","dropdown__button":"styles_dropdown__button__AI1vG","dropdown__caret":"styles_dropdown__caret__AbzjV","dropdown--socials":"styles_dropdown--socials__8J3PX","dropdown--center":"styles_dropdown--center__RZ_XH","dropdown--p-md":"styles_dropdown--p-md__fBkmc","dropdown--custom":"styles_dropdown--custom__FxnEf","dropdown--is-active":"styles_dropdown--is-active__rJu4v"};

/***/ }),

/***/ 860:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__KW2MK","menu__trigger":"styles_menu__trigger__X_jME","menu__content":"styles_menu__content__m5m53","menu__overflow":"styles_menu__overflow__GWS_a","isOpen":"styles_isOpen__LECPH","menu__footer":"styles_menu__footer__JABf4"};

/***/ }),

/***/ 58621:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"field":"styles_field__pVNyu","field--simple":"styles_field--simple__0JeUM","field--accent":"styles_field--accent__E6f7y","field__input--is-active":"styles_field__input--is-active__JxIUq","field__prepend":"styles_field__prepend__aLO0T","field__icons":"styles_field__icons__CnSXw","field__label":"styles_field__label__nafhT","field__error":"styles_field__error__SJd3B","field__input":"styles_field__input__5sMs9","field_icons":"styles_field_icons__IdtQb","form__icons":"styles_form__icons__8pzst","field__input--error":"styles_field__input--error__5w2Hf","field__input--valid":"styles_field__input--valid__2Pe92","field__apend":"styles_field__apend__qnDlS","field__icon":"styles_field__icon__j_JlC","field__angle":"styles_field__angle__xLz3T","field__optional":"styles_field__optional__JA0rP","field--p-xs":"styles_field--p-xs__cuDOF","field--dark":"styles_field--dark__WDzAJ","field--gray":"styles_field--gray__uYjtv","field--underline":"styles_field--underline__CM9Np","field--hidden":"styles_field--hidden__5IHB0","field--dropdown":"styles_field--dropdown__FZzvc","field--full-width":"styles_field--full-width__Ih7jn","field--t-unset":"styles_field--t-unset__XT6Rk","field--font-primary":"styles_field--font-primary__cDd8l","field--white":"styles_field--white__PwZnG","field--color-white":"styles_field--color-white__bsrpE","field--top":"styles_field--top__VIrSi"};

/***/ }),

/***/ 26384:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radio":"styles_radio__8T_tk","radio__checkmark":"styles_radio__checkmark__53Nqf","radio--is-close":"styles_radio--is-close__M_xXZ","radio--inline":"styles_radio--inline__bjNal","radio--disabled":"styles_radio--disabled__x1apB","radio--agreement":"styles_radio--agreement__geulO","radio__label":"styles_radio__label__e02rM","radio--boxed":"styles_radio--boxed__e0IRf","radio--underline":"styles_radio--underline__wDtjm","radio--small":"styles_radio--small__BBDuo","radio--white":"styles_radio--white__rOzF9"};

/***/ }),

/***/ 40255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"language":"styles_language__p5ng2","languages":"styles_languages__wjQvL"};

/***/ }),

/***/ 26670:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3vk_X","form__footer":"styles_form__footer__7Mb5p"};

/***/ }),

/***/ 65458:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bar":"styles_bar__XTTDT","bar__phone":"styles_bar__phone__hxlNi","bar__item":"styles_bar__item__44d8m","bar__item--active":"styles_bar__item--active__WDHqo","bar__icon":"styles_bar__icon__3wQSj","bar__dot":"styles_bar__dot__tz0zU"};

/***/ }),

/***/ 54201:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__wY6vt","menu__trigger":"styles_menu__trigger__ccefq","menu__label":"styles_menu__label__fK8Qm","menu__hamburger":"styles_menu__hamburger__QBj5w","menu__content":"styles_menu__content__fq8UV","menu__overflow":"styles_menu__overflow__QNK6R","isOpen":"styles_isOpen__9V35Y","menu__item":"styles_menu__item__lwEi1","menu__item--current":"styles_menu__item--current___X_Cr","menu__button":"styles_menu__button__f_Ydg","menu__footer":"styles_menu__footer__XN9Do"};

/***/ }),

/***/ 83954:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"rentals":"styles_rentals__uaeJT","rentals__grid":"styles_rentals__grid__r7pNv","rentals__flex":"styles_rentals__flex__w8Nng","rentals__column":"styles_rentals__column__Wbpa4","rentals__list":"styles_rentals__list__CWm2P","rentals__listItem":"styles_rentals__listItem__kCTmF","rentals__listItem--last":"styles_rentals__listItem--last__N7Ges","rentals__listItem--main":"styles_rentals__listItem--main__w6G_f","rentals__listItem--is-active":"styles_rentals__listItem--is-active__HdP0y","rentals__link":"styles_rentals__link__js1_g","rentals__title":"styles_rentals__title__gdjid","rentals__link--is-active":"styles_rentals__link--is-active__KlFbF"};

/***/ }),

/***/ 51590:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigation":"styles_navigation__lcwB7","navigation__button":"styles_navigation__button__lnQlg","navigation__items":"styles_navigation__items__hJohy","navigation__search":"styles_navigation__search__LSnSG","navigation__item":"styles_navigation__item__z0R_v","navigation__item--active":"styles_navigation__item--active__07IsO","navigation__dot":"styles_navigation__dot__afCiO","logo":"styles_logo__XISCa","logo--current":"styles_logo--current__oirUE","column":"styles_column__JIR7E"};

/***/ }),

/***/ 90444:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__M7Huu"};

/***/ }),

/***/ 37501:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__fV353","main--one-section":"styles_main--one-section__Arr15","main__content":"styles_main__content__vQds9","main__circle":"styles_main__circle__5mBLz","placeholder":"styles_placeholder__Av6Qu","shimmer":"styles_shimmer__QMJze"};

/***/ })

}]);